<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
                     <!--style="min-height: 300px; background-image: url(img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">-->
            <!-- Mask -->
            <span class="mask bg-gradient-dbm opacity-8"></span>
        </base-header>

        <div v-if="edit" class="container-fluid mt--7" v-bind:style="{cursor:pointer2}" @keydown.esc="escEdit">
            <div class="row">
                <div class="col-lg-12 center">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Información cliente</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <base-button slot="title" type="secondary" class="btn" size="sm" v-on:click="escEdit">
                                        Cancelar
                                    </base-button>
                                    <base-button slot="title" type="primary" class="btn" size="sm" v-on:click="uploadChanges()">
                                        Guardar
                                    </base-button>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <div>
                                    <h6 class="heading-small text-muted mb-4 col-lg-11">Información general</h6>
                                </div>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Nombre"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.name"/>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Primer apellido"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.lastname_1"/>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Segundo apellido"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.lastname_2"/>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Teléfono"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.phone"/>
                                        </div>
                                        <div class="col-lg-5" style="alignment: bottom">
                                            <base-input alternative=""
                                                        label="Correo electrónico"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.email"/>
                                        </div>
                                        <div class="col-lg-3">
                                            <label class="form-control-label">
                                                Fecha de nacimiento
                                            </label>
                                            <flat-pickr v-model="client.birthday" :config="{}" class="form-control form-control-alternative" data-vv-as="Fecha" name="date" style="background-color: #FFFFFF"/>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 text-center">
                                            <base-dropdown>
                                                <base-button slot="title" type="outline" class="dropdown-toggle" size="sm" style="margin-top: 15px; white-space: normal"
                                                 :class="gender === null ? 'text-danger' : ''">
                                                    {{gender ? 'Género ' + gender : "Selecciona género"}}
                                                </base-button>
                                                <a class="dropdown-item" v-on:click="setGender('Masculino')">Masculino</a>
                                                <a class="dropdown-item" v-on:click="setGender('Femenino')">Femenino</a>
                                            </base-dropdown>
                                            <base-dropdown>
                                                <base-button slot="title" type="outline" class="dropdown-toggle" size="sm" style="margin-top: 10px; white-space: normal"
                                                             :class="stateOfBirth === null ? 'text-danger' : ''">
                                                    {{stateOfBirth ? 'Nacido en ' + stateOfBirth:"Estado de nacimiento"}}
                                                </base-button>
                                                <a class="dropdown-item" v-for="(state, index) in mxStates" :key="index"
                                                   v-on:click="setMxState(state)">{{state.state}}</a>
                                            </base-dropdown>
                                        </div>
                                        <div class="col-lg-2 text-center">
                                            <base-dropdown>
                                                <base-button slot="title" type="outline" class="dropdown-toggle" size="sm" style="margin-top: 15px; white-space: normal"
                                                             :class="client.civil_status === null ? 'text-danger' : ''">
                                                    {{client.civil_status ? client.civil_status : "Estado civil"}}
                                                </base-button>
                                                <a class="dropdown-item" v-on:click="clientCivilStatusSelected('Casado')">Casado</a>
                                                <a class="dropdown-item" v-on:click="clientCivilStatusSelected('Soltero')">Soltero</a>
                                            </base-dropdown>
                                            <base-dropdown>
                                                <base-button slot="title" type="outline" class="dropdown-toggle" size="sm" style="margin-top: 10px; white-space: normal"
                                                             :class="client.economic_activity === null ? 'text-danger' : ''">
                                                    {{client.economic_activity ? getEconomicActivity() : "Actividad económica"}}
                                                </base-button>
                                                <a class="dropdown-item" v-for="(activity, index) in economicActivities" :key="index"
                                                   v-on:click="setEconomicActivity(activity.id)">{{activity.activity}}</a>
                                            </base-dropdown>
                                        </div>
                                        <div class="col-lg-2">
                                            <base-input alternative=""
                                                        label="RFC"
                                                        placeholder="13 dígitos"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.rfc"/>
                                        </div>
                                        <div class="col-lg-3">
                                            <base-input alternative=""
                                                        label="CURP"
                                                        placeholder="18 dígitos"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.curp"/>
                                        </div>
                                        <div class="col-lg-3">
                                            <base-input alternative=""
                                                        label="Identificación oficial"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.id_number"/>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />

                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Dirección</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <base-input alternative=""
                                                        label="Calle"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.addr_street"/>
                                        </div>
                                        <div class="col-md-2">
                                            <base-input alternative=""
                                                        label="Número exterior"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.addr_extnum"/>
                                        </div>
                                        <div class="col-md-2">
                                            <base-input alternative=""
                                                        label="Número interior"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.addr_intnum"/>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <base-input alternative=""
                                                        label="Código postal"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.addr_postal_code"
                                                        v-on:input="postalCodeUpdated"/>
                                        </div>
                                        <div class="col-lg-1">
                                            <base-dropdown v-if="postalCodes.length > 1">
                                                <a class="dropdown-item" v-for="(postalCode, index) in postalCodes" :key="index"
                                                   v-on:click="postalCodeSelected(postalCode)">{{postalCode.postal_code}}</a>
                                            </base-dropdown>
                                        </div>
                                        <div class="col-lg-3">
                                            <base-input alternative=""
                                                        label="Colonia"
                                                        input-classes="form-control-alternative"
                                                        v-model="client.addr_sublocality"/>
                                        </div>
                                        <div class="col-lg-1">
                                            <base-dropdown v-if="sublocalities.length > 0">
                                                <a class="dropdown-item" v-for="(sublocality, index) in sublocalities" :key="index"
                                                   v-on:click="sublocalitySelected(sublocality)">{{sublocality}}</a>
                                            </base-dropdown>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Ciudad"
                                                        input-classes="form-control-alternative"
                                                        v-model="locality"/>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4"/>

                                <!-- Beneficiary -->
                                <div>
                                    <h6 class="heading-small text-muted mb-4 col-lg-11">Información del beneficiario</h6>
                                </div>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Nombre"
                                                        input-classes="form-control-alternative"
                                                        v-model="beneficiary.name"/>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Primer apellido"
                                                        input-classes="form-control-alternative"
                                                        v-model="beneficiary.lastname_1"/>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Segundo apellido"
                                                        input-classes="form-control-alternative"
                                                        v-model="beneficiary.lastname_2"/>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <label class="form-control-label">
                                                Fecha de nacimiento
                                            </label>
                                            <flat-pickr v-model="beneficiary.birthday" :config="{}" class="form-control form-control-alternative" data-vv-as="Fecha" name="date" style="background-color: #FFFFFF"/>
                                        </div>
                                        <div class="col-lg-4 text-center">
                                            <base-dropdown style="margin-top: 30px">
                                                <base-button slot="title" type="outline" class="dropdown-toggle"
                                                             :class="beneficiaryGender ? '' : 'text-danger'">
                                                    {{beneficiary.gender ? 'Género ' + beneficiaryGender : "Selecciona género"}}
                                                </base-button>
                                                <a class="dropdown-item" v-on:click="setBeneficiaryGender('Masculino')">Masculino</a>
                                                <a class="dropdown-item" v-on:click="setBeneficiaryGender('Femenino')">Femenino</a>
                                            </base-dropdown>
                                        </div>
                                        <div class="col-lg-4 text-center">
                                            <base-dropdown style="margin-top: 30px">
                                                <base-button slot="title" type="outline" class="dropdown-toggle" large="true"
                                                             :class="beneficiary.civil_status ? '' : 'text-danger'">
                                                    {{beneficiary.civil_status ? beneficiary.civil_status : "Estado civil"}}
                                                </base-button>
                                                <a class="dropdown-item" v-on:click="beneficiaryCivilStatusSelected('Casado')">Casado</a>
                                                <a class="dropdown-item" v-on:click="beneficiaryCivilStatusSelected('Soltero')">Soltero</a>
                                            </base-dropdown>
                                        </div>
                                    </div>
                                    <div class="row">

                                    </div>
                                </div>

                                <!-- Agregar cuentas con deudas & calculadora-->
                                <tabs v-if="false" fill class="flex-column flex-md-row" v-on:tabSelected="tabSelected">
                                    <card shadow>
                                        <tab-pane title="accounts" id="accounts">
                                        <span slot="title">
                                            <i class="fas fa-file-invoice-dollar"></i>
                                            Agregar cuentas
                                        </span>
                                            <div class="pl-lg-">
                                                <div class="d-flex flex-row-reverse">
                                                    <base-button v-if="tokenUrl" id="tokenUrlLabel" class="p-2" size="sm" type="primary" style="margin-right: 12px;">
                                                        <a style="color: #FFFFFF;" v-on:click="createFinamigoAccount()" :href="tokenUrl" target="_blank">Enlace para el cliente</a>
                                                    </base-button>
                                                    <base-button v-else-if="clientValidation.status === 2 && false" id="requestSignatureToken" class="p-2" size="sm" v-on:click="requestSignatureToken(false)">
                                                        Obtener reporte de crédito
                                                    </base-button>
                                                    <base-button v-if="clientValidation.status === 0" class="p-2" size="sm" v-on:click="requestValidationCode()">
                                                        Solicitar reporte de crédito
                                                    </base-button>
                                                    <div class="d-inline-flex justify-content-end" v-if="clientValidation.status === 1">
                                                        <base-input class="align-self-baseline"
                                                                    alternative=""
                                                                    placeholder="Código de verificación"
                                                                    input-classes="form-control-alternative"
                                                                    v-model="clientValidation.pin"/>
                                                        <base-button class="align-self-baseline" size="sm" v-on:click="validateClient()" style="margin-left: 12px">
                                                            Validar código
                                                        </base-button>
                                                    </div>
                                                </div>
                                                <div>
                                                    <future-accounts-table title="Cuentas a ingresar al programa"
                                                                                  :data="futureAccountTableData"
                                                                                  v-on:onNewItem="newFutureAccount"
                                                                                  v-on:showDetails="showAccountInformationModal"
                                                                                  style="margin-top: 20px"/>
                                                </div>
                                            </div>
                                        </tab-pane>

                                        <tab-pane title="calculator" id="calculator">
                                            <span slot="title">
                                                <i class="fas fa-calculator"></i>
                                                Calculadora de reparación
                                            </span>
                                            <div>
                                                <base-slider
                                                        :range="{min: 4, max: 48}"
                                                        :options="{step: 1}"
                                                        v-model="period"
                                                        v-on:input="requestPaymentPlan"/>
                                                <div class="card-profile-stats d-flex justify-content-center">
                                                    <div>
                                                        <base-button v-if="period > 4" style="border-radius: 50px;width: 55px;height: 55px;" v-on:click="requestPaymentPlan(period - 1)"><i class="fas fa-minus"></i></base-button>
                                                    </div>
                                                    <div>
                                                        <span class="heading">{{formatDecPost(period, 0)}} meses</span>
                                                        <span class="description">Duración del programa</span>
                                                    </div>
                                                    <div>
                                                        <base-button style="border-radius: 50px;width: 55px;height: 55px;" v-on:click="requestPaymentPlan(period + 1)"><i class="fas fa-plus"></i></base-button>
                                                    </div>
                                                </div>
                                                <h2 class="text-primary"></h2>
                                                <div class="card-profile-stats d-flex justify-content-center">
                                                    <div>
                                                        <span class="heading text-primary" style="font-size: 25pt">{{this.$formatCurrency(paymentPlan.montlyFee, 2)}}</span>
                                                        <span class="description">Pago mensual</span>
                                                    </div>
                                                </div>
                                                <div class="card-profile-stats d-flex justify-content-center">
                                                    <div>
                                                        <span class="heading">{{this.$formatCurrency(paymentPlan.totalDebt)}}</span>
                                                        <span class="description">Deuda total</span>
                                                    </div>
                                                    <div>
                                                        <span class="heading">{{this.$formatCurrency(paymentPlan.willPay)}}</span>
                                                        <span class="description">Se pagará con DB Menos</span>
                                                    </div>
                                                    <div>
                                                        <span class="heading">{{formatDecPost(paymentPlan.discount, 2)}} %</span>
                                                        <span class="description">Descuento estimado</span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <payment-plan-debts-table title="Cuentas a ingresar al programa"
                                                                              :data="paymentPlan.debts"
                                                                              style="margin-top: 20px"/>
                                                </div>
                                            </div>
                                        </tab-pane>
                                    </card>
                                </tabs>

                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
        <div v-else class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-8 center">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a>
                                        <img src="img/theme/avatar.jpg" class="rounded-circle" style="background-color: aliceblue">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                                <base-button size="sm" type="default" class="float-right" v-on:click="edit=true">Editar</base-button>
                                <br>
                                <base-button size="sm" type="danger" class="float-right" v-on:click="resetPassword()">Poner contraseña por defecto</base-button>
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="row card-profile-stats d-flex justify-content-center mt-md-1" v-if="client.contract > 0">
                                        <div>
                                            <span class="heading">{{client.payday}}</span>
                                            <span class="description">Día depósito</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{this.$formatCurrency(client.monthly_savings)}}</span>
                                            <span class="description">Ahorro mensual</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{client.program_duration}}</span>
                                            <span class="description">Duración</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{$formatCurrency(client.balance)}}</span>
                                            <span class="description">Saldo</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{$formatCurrency(client.total_debt)}}</span>
                                            <span class="description">Monto Deuda Ingresada</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{clientPaymentResume.duePaymentCount}}</span>
                                            <span class="description">Meses de atraso</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{this.$formatCurrency(clientPaymentResume.duePaymentSum)}}</span>
                                            <span class="description">Monto atrasado</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{formatDate(clientPaymentResume.nextPaymentDate)}}</span>
                                            <span class="description">Fecha proximo pago</span>
                                        </div>
                                    </div>
                                    <div v-else class="card-profile-stats d-flex justify-content-center mt-md-5">

                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div class="col" :title="titleProgressBar">
                                    <div class="progress" style="height:8px">
                                        <div class="progress-bar" role="progressbar" :style="widthProgressBar">
                                            <!--div class="row">
                                                <div v-if="client.step_basic_information" title="Información básica" class="col text-center"></div>
                                                <div v-if="client.step_basic_information2" title="Información básica 2" class="col text-center"></div>
                                                <div v-if="client.step_address_information" title="Domicilio" class="col text-center"></div>
                                                <div v-if="client.step_official_id" title="Identificación oficial" class="col text-center"></div>
                                                <div v-if="client.step_credit_report_signature" title="Firma reporte de crédito" class="col text-center"></div>
                                                <div v-if="client.step_credit_report" title="Reporte de crédito" class="col text-center"></div>
                                                <div v-if="client.step_program_calculation" title="Programa de cálculo" class="col text-center"></div>
                                                <div v-if="client.step_complete_profile" title="Perfil completo" class="col text-center"></div>
                                                <div v-if="client.step_contract" title="Contrato" class="col text-center"></div>
                                                <div v-if="client.step_active" title="Activo" class="col text-center"></div>
                                            </div-->
                                        </div>
                                    </div>
                                </div>
                                <h2>
                                    {{client.name}} {{client.lastname_1}} {{client.lastname_2}}
                                </h2>
                                <div v-if="client.first_payment" class="col">
                                    <div class="card-profile-stats d-flex justify-content-center">
                                        <span class="heading" v-on:click="updatePaymentStatus()" :class="client.program_status === -1 ? 'text-danger' : 'text-success'">
                                            {{client.program_status===1 ? "Adelantado" : client.program_status===0 ? "Al corriente" : "Atrasado"}}
                                        </span>
                                    </div>
                                </div>
                                {{client.email}}
                                <div class="row pt-4">
                                    <div v-if="clientCalculations && clientCalculations.debts" class="col">
                                        <base-button id="showModal" type="outline-info" class="p-2" size="sm" v-on:click="setCalc(clientCalculations)">
                                            Ver calculadora
                                        </base-button>
                                    </div>
                                    <div v-if="client.phone" class="col">
                                        <base-button id="showSendMessage" type="outline-info" class="p-2" size="sm" v-on:click="setTypeMessage('SMS')">
                                            Enviar SMS
                                        </base-button>
                                    </div>
                                    <div v-if="client.phone" class="col">
                                        <base-button id="showSendPushNotification" type="outline-info" class="p-2" size="sm" v-on:click="setTypeMessage('PN')">
                                            Notificación push
                                        </base-button>
                                    </div>
                                    <!--div v-if="report && calculos && calculos.debts" class="col">
                                        <base-button id="showCreditReport" type="outline-warning" class="p-2" size="sm" v-on:click="showModalReport=true">
                                            Ver reporte de crédito
                                        </base-button>
                                    </div-->
                                </div>
                                
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center">
                                        <div>
                                            <span class="heading">{{client.birthday ? formatDate(client.birthday) : '-'}}</span>
                                            <span class="description">Fecha de nacimiento</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{client.phone ? client.phone : '-'}}</span>
                                            <span class="description">Teléfono</span>
                                        </div>
                                        <div v-if="isAdmin">
                                            <span class="heading">{{getConsultantName(client.consultant)}}</span>
                                            <span class="description">Asesor DBM</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center">
                                        <div>
                                            <span class="heading">{{client.rfc ? client.rfc : "-"}}</span>
                                            <span class="description">RFC</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{client.curp ? client.curp : '-'}}</span>
                                            <span class="description">CURP</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{client.id_number ? client.id_number : '-'}}</span>
                                            <span class="description">Identificación oficial</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center">
                                        <div>
                                            <span class="heading">
                                                {{client.addr_street}} {{client.addr_extnum}}{{client.addr_intnum ? " " + client.addr_intnum : ""}}, {{client.addr_sublocality}}
                                            </span>
                                            <span class="description">Dirección</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" v-if="canRequestCreditReport() && client.contract === 0">
                                    <div class="card-profile-stats d-flex justify-content-center">
                                        <div>
                                            <span class="heading">
                                                <base-button slot="title" class="" type="primary" size="lg" style="white-space: normal" v-on:click="requestSignatureToken(false)">
                                                    Solicitar
                                                </base-button>
                                            </span>
                                            <span class="description">Autorización consulta reporte de crédito</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <!-- Create contract -->
                                    <hr class="my-4" />
                                    <div>
                                        <h6 class="heading-small text-muted mb-4">Contrato</h6>
                                        <div class="pl-lg-4">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <base-input alternative=""
                                                                label="Día de depósito mensual"
                                                                input-classes="form-control-alternative"
                                                                v-model="client.payday"/>
                                                </div>
                                                <div class="col-md-4">
                                                    <base-input alternative=""
                                                                :disabled="client.contract > 1 && contract.commission_percentage && !(isAdmin||isManagerService)"
                                                                label="Porcentaje de comisión"
                                                                input-classes="form-control-alternative"
                                                                v-model="client.commission_percentage"/>
                                                </div>
                                                <div class="col-md-4">
                                                    <base-input alternative=""
                                                                :disabled="client.contract > 1 && contract.program_duration && !(isAdmin||isManagerService)"
                                                                label="Duración del programa (Meses)"
                                                                input-classes="form-control-alternative"
                                                                v-model="client.program_duration"/>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-5">
                                                    <base-input alternative=""
                                                                :disabled="client.contract > 1 && contract.monthly_savings && !(isAdmin||isManagerService)"
                                                                label="Pago mensual"
                                                                input-classes="form-control-alternative"
                                                                v-model="client.monthly_savings"/>
                                                </div>
                                                <div class="col-md-5">
                                                    <label class="form-control-label">
                                                        Fecha de primer pago
                                                    </label>
                                                    <flat-pickr
                                                            v-model="client.first_payment" :config="{}"
                                                            class="form-control form-control-alternative" data-vv-as="Fecha"
                                                            name="first_payment" style="background-color: #FFFFFF"/>
                                                </div>
                                                <div class="col-md-2">
                                                    <base-button slot="title" class="" type="primary" size="sm" style="margin-top: 35px; white-space: normal" v-on:click="uploadContract()">
                                                        {{client.contract > 0? 'Actualizar': 'Crear'}}
                                                    </base-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Create finamigo account -->
                                    <div v-if="client.contract > 0">
                                        <hr class="my-4" />
                                        <div>
                                            <h6 class="heading-small text-muted mb-4">Cuenta de ahorro DBMenos</h6>
                                            <div class="pl-lg-4">
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="card-profile-stats d-flex justify-content-center">
                                                            <div>
                                                                <span class="heading">
                                                                    {{(finamigo && finamigo.account) ?
                                                                        (false) ?
                                                                            '•••• - ' + finamigo.account.substring(finamigo.account.length - 5, finamigo.account.length) :
                                                                            finamigo.account
                                                                        : "-"
                                                                    }}
                                                                </span>
                                                                <span class="description">Cuenta</span>
                                                            </div>
                                                            <div>
                                                                <span class="heading">
                                                                    {{(finamigo && finamigo.banamex) ?
                                                                        (false) ?
                                                                            '•••• - ' + finamigo.banamex.substring(11, finamigo.banamex.length) :
                                                                            finamigo.banamex
                                                                        : "-"
                                                                    }}
                                                                </span>
                                                                <span class="description">Referencia Banamex</span>
                                                            </div>
                                                            <div>
                                                                <span class="heading">
                                                                    {{(finamigo && finamigo.bbva) ?
                                                                        (false) ?
                                                                            '•••• - ' + finamigo.bbva.substring(finamigo.bbva.length - 5, finamigo.bbva.length) :
                                                                            finamigo.bbva
                                                                        : "-"
                                                                    }}</span>
                                                                <span class="description">Referencia BBVA</span>
                                                            </div>
                                                            <div v-if="!isSeller && client.contract > 0 && client.payment_count > 0" class="col-md-0">
                                                                <!--base-button v-if="!showFinBalance" type="info" v-on:click="getFinamigoBalance" size="lg">Mostrar saldo</base-button-->
                                                                <span v-if="showFinBalance" class="heading">{{$formatCurrency(client.finamigoBalance)}}</span>
                                                                <span v-if="showFinBalance" class="description">Saldo Finamigo</span>
                                                            </div>
                                                            <div v-if="!(finamigo && finamigo.account)">
                                                                <base-button v-if="client.has_signature && client.for_contract" id="tokenUrlContractLabel" class="p-2" type="primary" style="margin-right: 12px;">
                                                                    <a style="color: #FFFFFF;" v-on:click="createFinamigoAccount()" target="_blank">Generar referencias bancarias</a>
                                                                </base-button>
                                                                <base-button v-else-if="hasCompleteProfile()" slot="title" class="" type="primary" style="white-space: normal" v-on:click="requestSignatureToken(true)">
                                                                    Solicitar firma de contrato
                                                                </base-button>
                                                                <base-button v-else slot="title" class="" type="warning" style="white-space: normal">
                                                                    Perfil incompleto
                                                                </base-button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <hr class="my-4" />
                                        <div>
                                            <h6 class="heading-small text-muted mb-4">Documentos finamigo</h6>
                                            <div class="px-lg-4">
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="card-profile-stats d-flex justify-content-center">
                                                            <i :class="iconoFinAmigo('far fa-file-image', files.ID, files.upload_ID)" v-on:click="uploadFinamigoFile('ID')" style="font-size: 40px"/>
                                                        </div>
                                                        <span class="description">ID</span>
                                                    </div>
                                                    <div class="col">
                                                        <div class="card-profile-stats d-flex justify-content-center">
                                                            <i :class="iconoFinAmigo('far fa-file-image', files.ID_B, files.upload_ID_B)" v-on:click="uploadFinamigoFile('ID_B')" style="font-size: 40px"/>
                                                        </div>
                                                        <span class="description">ID_B</span>
                                                    </div>
                                                    <div class="col">
                                                        <div class="card-profile-stats d-flex justify-content-center">
                                                            <i :class="iconoFinAmigo('far fa-file-image', files.ADDRESS, files.upload_ADDRESS)" v-on:click="uploadFinamigoFile('ADDRESS')" style="font-size: 40px"/>
                                                        </div>
                                                        <span class="description">ADDRESS</span>
                                                    </div>
                                                    <div class="col">
                                                        <div class="card-profile-stats d-flex justify-content-center">
                                                            <i :class="iconoFinAmigo('far fa-file-pdf', files.CURP, files.upload_CURP)" v-on:click="uploadFinamigoFile('CURP')" style="font-size: 40px"/>
                                                        </div>
                                                        <span class="description">CURP</span>
                                                    </div>
                                                    <div class="col">
                                                        <div class="card-profile-stats d-flex justify-content-center">
                                                            <i :class="iconoFinAmigo('far fa-file-pdf', files.FIN_MANIFEST, files.upload_FIN_MANIFEST)" v-on:click="uploadFinamigoFile('FIN_MANIFEST')" style="font-size: 40px"/>
                                                        </div>
                                                        <span class="description">MANIFESTO</span>
                                                    </div>
                                                    <div class="col">
                                                        <div class="card-profile-stats d-flex justify-content-center">
                                                            <i :class="iconoFinAmigo('far fa-file-pdf', files.FIN_CONTRACT, files.upload_FIN_CONTRACT)" v-on:click="uploadFinamigoFile('FIN_CONTRACT')" style="font-size: 40px"/>
                                                        </div>
                                                        <span class="description">CONTRATO</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="card card-profile shadow" style="margin-top: 20px">
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col" v-if="client.id > 0">
                                    <h6 class="heading-small text-muted mb-4">Documentos</h6>
                                    <div class="pl-lg-4">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <dropbox text="Identificación oficial" type="ID" :userid="client.id" :files="userFiles" v-on:uploadFile="uploadFile"/>
                                            </div>
                                            <div class="col-md-3">
                                                <dropbox text="Reporte de crédito" type="CREDIT_INFO" :userid="client.id" :files="userFiles" v-on:uploadFile="uploadFile"/>
                                            </div>
                                            <div class="col-md-3">
                                                <dropbox text="Comprobante de domicilio" type="ADDRESS" :userid="client.id" :files="userFiles" v-on:uploadFile="uploadFile"/>
                                            </div>
                                            <div class="col-md-3">
                                                <dropbox text="Contrato" type="CONTRACT" :userid="client.id" :files="userFiles" v-on:uploadFile="uploadFile"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div v-if="report">
                        <credit-report-table v-if="lengthsCreditReports.dbmAccounts>0" title = "Cuentas que se pueden agregar al programa"
                                :amount="Number(client['total_savings'])"
                                :data="report && report['dbmAccounts'] ? report['dbmAccounts'] : []"
                                :pagination="paymentPagination"
                                :showCalc="true"
                                v-on:onNewItem="newPaymentModal = true"
                                v-on:pageSelected="paymentPageSelected"
                                v-on:onPaymentSelected="onPaymentSelected"
                                v-on:accountClick="accountClick"
                                v-on:showCalcClick="showCalcClick"
                                style="margin-top: 20px"/>

                        <credit-report-table v-if="lengthsCreditReports.otherAccounts>0" title = "Otras cuentas"
                                    :amount="Number(client['total_savings'])"
                                    :data="report && report['otherAccounts'] ? report['otherAccounts'] : []"
                                    :pagination="paymentPagination"
                                    v-on:onNewItem="newPaymentModal = true"
                                    v-on:pageSelected="paymentPageSelected"
                                    v-on:onPaymentSelected="onPaymentSelected"
                                    v-on:accountClick="accountClick"
                                    style="margin-top: 20px"/>
                    </div>

                    <div v-else class="card shadow" style="margin-top: 20px">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h6 class="heading-small text-muted mb-4">Estado del reporte de crédito:</h6>
                                    <span class="font-weight-bold ml-1 text-warning">{{getMessageReport(messageReport)}}</span>
                                </div>
                                <base-button v-if="!report" type="success" @click="updateCreditReport">Solicitar actualización</base-button>
                            </div>
                        </div>
                    </div>
                                    
                    <user-files-table title="Documentos"
                                      :data="userFilesTableData"
                                      :pagination="userFilesPagination"
                                      :client="client"
                                      :showCreateContractButton="canCreateDBMContract()"
                                      :create_contract_button_text="client.dbm_contract === 0 ? 'Generar contrato DBM' : 'Generar contrato nuevamente'"
                                      v-on:onNewItem="newUserFileModal = true"
                                      v-on:onCreateDBMenosContract="createDBMenosContract"
                                      v-on:pageSelected="userFilesPageSelected"
                                      style="margin-top: 20px"/>

                    <movements-table title = "Movimientos"
                                    :amount="Number(client.total_savings)"
                                    :data="movementsTableData"
                                    :pagination="movementsPagination"
                                    v-on:pageSelected="getMovementsTableData"
                                    style="margin-top: 20px"/>
                    <payments-table title = "Depósitos"
                                    :amount="Number(client.total_savings)"
                                    :data="paymentTableData"
                                    :pagination="paymentPagination"
                                    v-on:onNewItem="newPaymentModal = true"
                                    v-on:pageSelected="paymentPageSelected"
                                    v-on:onPaymentSelected="onPaymentSelected"
                                    style="margin-top: 20px"/>

                    <accounts-table title="Cuentas"
                                    :data="accountTableData"
                                    :pagination="accountPagination"
                                    v-on:onNewItem="newAccountModal"
                                    v-on:onSave="updateAccount"
                                    v-on:pageSelected="accountPageSelected"
                                    v-on:accountSelected="accountSelected"
                                    style="margin-top: 20px"/>

                    <commissions-table v-if="isAdmin"
                                       title="Comisiones"
                                       :amount="Number(client.total_commissions)"
                                       :data="commissionTableData"
                                       :pagination="commissionPagination"
                                       v-on:onNewItem="newCommissionModal = true"
                                       v-on:pageSelected="commissionPageSelected"
                                       style="margin-top: 20px"/>

                    <history-table title="Historial"
                                    :data="historyTableData"
                                    :pagination="historyPagination"
                                    v-on:pageSelected="getHistoryEvent"
                                    style="margin-top: 20px"/>

                    <user-status-tracing-table v-if="!isSeller" title="Servicio al cliente"
                                        :data="statusTracingTableDataCS"
                                        :pagination="statusTracingPaginationCS"
                                        v-on:newUserStatusTrace="typeTracingTable"
                                        v-on:pageSelected="getTracingTableDataCS"
                                        style="margin-top: 20px"/>

                    <user-status-tracing-table v-if="!isService" title="Seguimiento de ventas"
                                        :data="statusTracingTableDataS"
                                        :pagination="statusTracingPaginationS"
                                        v-on:newUserStatusTrace="typeTracingTable"
                                        v-on:pageSelected="getTracingTableDataS"
                                        style="margin-top: 20px"/>

                    <user-status-tracing-table title="Acciones cliente"
                                        :data="userActionsTableData"
                                        :pagination="userActionsPagination"
                                        v-on:newUserStatusTrace="typeTracingTable"
                                        v-on:pageSelected="getUserActionsTableData"
                                        style="margin-top: 20px"/>

                    <user-status-tracing-table v-if="(isAdmin || isManagerService) && client.step_active" 
                                        title="Inactivar programa"
                                        :data="userInactiveTableData"
                                        :pagination="userInactivePagination"
                                        v-on:newUserStatusTrace="typeTracingTable"
                                        v-on:pageSelected="getUserInactiveTableData"
                                        style="margin-top: 20px"/>

                </div>
            </div>
        </div>  

        <!-- Modals -->

        <modal :show.sync="futureAccountModal">
            <template slot="header">
                <h1 class="modal-title" id="exampleModalLabel">Cuenta obtenida en el reporte de crédito</h1>
            </template>
            <div class="row">
                <div class="col">
                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                        <div>
                            <span class="heading">{{formatDate(futureAccount.FechaActualizacion)}}</span>
                            <span class="description">Actualizada al</span>
                        </div>
                        <div>
                            <span class="heading">{{formatDate(futureAccount.FechaUltimoPago)}}</span>
                            <span class="description">Fecha último pago</span>
                        </div>
                        <div>
                            <span class="heading">$ {{formatDecPost(Number(futureAccount.LimiteCredito), 2)}}</span>
                            <span class="description">Límite de crédito</span>
                        </div>
                        <div>
                            <span class="heading">$ {{formatDecPost(Number(futureAccount.MontoPagar), 2)}}</span>
                            <span class="description">Monto a pagar</span>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <!--modal :show.sync="paidAccountModal">
            <template slot="header">
                <h1 class="modal-title" id="paidAccountModal">Liquidar cuenta</h1>
            </template>
            <div class="row">
                <div class="col">
                    <div class="card-profile-stats d-flex justify-content-center">
                        <dropbox text="" type="__" buttonText="Liquidar" :userid="client.id" :files="userFiles" v-on:uploadFile="setPaidAccount"/>
                    </div>
                </div>
            </div>
        </modal-->

        <modal :show.sync="newUserFileModal">
            <template slot="header">
                <h1 class="modal-title" id="newUserFileModal">Nuevo documento</h1>
            </template>
            <div class="row">
                <div class="col">
                    <div class="d-flex justify-content-center">
                        <base-dropdown>
                            <base-button slot="title" class="dropdown-toggle" type="primary" style="margin-top: 15px; white-space: normal">
                                {{fileType ? getFileType(fileType) : "Selecciona el tipo de documento"}}
                            </base-button>
                            <a class="dropdown-item" v-for="type in fileTypes" :key="type" v-on:click="fileType = type">{{getFileType(type)}}</a>
                        </base-dropdown>
                    </div>
                    <div class="card-profile-stats d-flex justify-content-center">
                        <dropbox text="" :type="fileType" :userid="client.id" :files="userFiles" v-on:uploadFile="uploadFile"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :show.sync="newPaymentModal">
            <template slot="header">
                <h1 class="modal-title" id="newPaymentModal">Nuevo depósito</h1>
            </template>
            <div class="row">
                <div class="col-md-6">
                    <label class="form-control-label">
                        Fecha de depósito
                    </label>
                    <flat-pickr v-model="newPayment.date" :config="{}" class="form-control form-control-alternative" data-vv-as="Fecha" name="date" style="background-color: #FFFFFF"/>
                </div>
                <div class="col-md-6">
                    <base-input alternative=""
                                label="Cantidad depositada"
                                input-classes="form-control-alternative"
                                v-model="newPayment.amount"/>
                </div>
                <div hidden class="col-md-6">
                    <label class="form-control-label">
                        Validar
                    </label>
                    <base-button slot="title" style="width: 100%; margin-top: 4px" :type="newPayment.validated?'primary':'danger'" class="btn" size="sm"
                                 v-on:click="changeNewPaymentValidation()">
                        {{newPayment.validated ? 'Pago validado' : 'Pago no validado'}}
                    </base-button>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="col">
                        <div class="card-profile-stats d-flex justify-content-center">
                            <dropbox text="" type="PAYMENT" v-on:uploadFile="uploadPayment"/>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal :show.sync="newCommissionModal">
            <template slot="header">
                <h1 class="modal-title" id="newCommissionModal">Nueva comisión</h1>
            </template>
            <div class="row">
                <div class="col-md-6">
                    <label class="form-control-label">
                        Fecha de cobro de comisión
                    </label>
                    <flat-pickr v-model="newCommission.date" :config="{}" class="form-control form-control-alternative" data-vv-as="Fecha" name="date" style="background-color: #FFFFFF"/>
                </div>
                <div class="col-md-6">
                    <base-input alternative=""
                                label="Comisión cobrada"
                                input-classes="form-control-alternative"
                                v-model="newCommission.amount"/>
                </div>
            </div>
            <div class="row">
                <div class="col text-right">
                    <base-button slot="title" style="" type="primary" class="btn" v-on:click="createCommission()">
                        Subir comisión
                    </base-button>
                </div>
            </div>
        </modal>

        <modal :show.sync="paymentModal">
            <template slot="header">
                <h1 class="modal-title" id="paymentModal">Depósito</h1>
            </template>
            <div class="row">
                <div class="card-profile-stats d-flex justify-content-around mb-4" style="width:100%">
                    <div class="p-2">
                        <span class="heading">{{selectedPayment.id}}</span>
                        <span class="description">Identificador</span>
                    </div>
                    <div class="p-2">
                        <label class="form-control-label">
                            Creada el
                        </label>
                        <flat-pickr v-model="selectedPayment.created" :config="{}" class="form-control form-control-alternative" data-vv-as="Fecha" name="date" style="background-color: #FFFFFF"/>
                    </div>
                    <div class="p-2">
                        <base-input alternative=""
                                label="Monto depositado"
                                input-classes="form-control-alternative"
                                v-model="selectedPayment.amount"/>
                    </div>
                    <!--div class="p-2">
                        <span class="heading">{{formatDate(selectedPayment.created)}}</span>
                        <span class="description">Creada el</span>
                    </div>
                    <div class="p-2">
                        <span class="heading">$ {{formatDecPost(Number(selectedPayment.amount), 2)}}</span>
                        <span class="description">Monto depositado</span>
                    </div-->
                    <div v-if="isAdmin && user.view_only === 0" class="p-2">
                        <base-button slot="title" style="width: 100%; margin-top: 4px" :type="selectedPayment.validated?'primary':'danger'" class="btn" v-on:click="updatePayment()">
                            {{selectedPayment.validated ? 'Depósito validado' : 'Depósito no validado'}}
                        </base-button>
                        <span class="description">{{selectedPayment.validated_on ? formatDate(selectedPayment.validated_on) : "No validado"}}</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="img-center">
                    <img :src="selectedPayment.fileurl ? selectedPayment.fileurl : getPaymentFile(selectedPayment.id)" style="max-height: 200px">
                </div>
            </div>
            <template slot="footer">
                <base-button class="btn-sm" type="danger" v-on:click="paymentModal=false">Cancelar</base-button>
                <base-button class="btn-sm" type="primary" v-on:click="updatePayment(true)">Guardar cambios</base-button>
            </template>
        </modal>

        <modal :show.sync="tracingModal" v-bind:large="true">
            <template slot="header">
                <h2 class="mb-0" id="TracingLead" style="margin-top: 20px; margin-left: 10px">{{client.name}} {{client.lastname_1}} {{client.lastname_2}}</h2>
            </template>
            <div class="col-lg-12">
                <base-dropdown v-if="tracingStatus==='Acciones cliente'||tracingStatus === 'Inactivar programa'">
                    <base-button slot="title" type="success" class="dropdown-toggle">
                        {{newTrace.status ? newTrace.status : "Seleccionar"}}
                    </base-button>
                    <a class="dropdown-item" v-for="(value, index) in tracingStatus === 'Inactivar programa' ? userInactiveCatalog :  userActionsCatalog" :key="index" v-on:click="setTraceStatus(value)">{{value.value}}</a>
                </base-dropdown>
                <base-dropdown v-else>
                    <base-button slot="title" type="success" class="dropdown-toggle">
                        {{newTrace.status ? newTrace.status : "Seleccionar"}}
                    </base-button>
                    <a class="dropdown-item" v-for="(status, index) in tracingStatus === 'Seguimiento de ventas' ? leadStatus : userTracingStatusCatalog" :key="index" v-on:click="setTraceStatus(status)">{{status.status}}</a>
                </base-dropdown>
                <base-input alternative=""
                            placeholder="Comentarios"
                            input-classes="form-control-alternative"
                            style="margin-top: 20px"
                            v-model="newTrace.comments"/>
            </div>
            <div class="col text-right">
                <base-button slot="title" type="primary" v-on:click="uploadTrace()">Crear</base-button>
            </div>
        </modal>

        <modal :show.sync="sendMessageModal" v-on:close="sendMessageModal" v-bind:large="true">
            <template slot="header">
                <h2 class="mb-0" style="margin-top: 20px; margin-left: 10px">Para: {{client.name}}</h2>
            </template>
            <base-input v-if="this.typeTheMessage==='PN'" alternative=""
                        label="Título"
                        placeholder="Escribe un titulo..."
                        v-model="pushNotTitle"/>
            <base-input alternative=""
                        label="Mensaje SMS"
                        placeholder="Escribe un mensaje..."
                        v-model="theMessage"/>
            <template slot="footer">
                <base-button type="primary" @click="sendMessage()">Enviar</base-button>
            </template>
         </modal>

        <modal :show.sync="accountModal" v-on:close="closeAccountModal()" v-bind:large="true">
            <template slot="header">
                <h2 class="mb-0" id="acountModal" style="margin-top: 20px; margin-left: 10px">{{newAccount ? "Añadir cuenta" : "Editar cuenta"}}</h2>
            </template>
            <div class="row">
                <div class="col" v-bind:style='{cursor:pointer}'>
                    <base-dropdown>
                        <base-button slot="title" type="outline" class="dropdown-toggle" size="lg" style="margin-top: 10px; white-space: normal">
                             {{accountInModal.bank ? getBank(accountInModal.bank).name : "Selecciona el banco"}}
                        </base-button>
                        <a class="dropdown-item" v-for="(bank, index) in banks" :key="index"
                            v-on:click="setBankInAccount(bank)">{{bank.name}}</a>
                    </base-dropdown>
                </div>
                <div class="col">
                    <base-input alternative=""
                                label="Número de cuenta"
                                input-classes="form-control-alternative"
                                v-model="accountInModal.account"/>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <base-input alternative=""
                                label="Total adeudado"
                                input-classes="form-control-alternative"
                                v-model="accountInModal.amount"/>
                </div>
                <div class="col" v-if="newAccount">
                    <base-input alternative=""
                                label="Descuento actual"
                                input-classes="form-control-alternative"
                                v-model="discount"
                                v-bind:readonly="true"/>
                </div>
                <div class="col" v-else>
                    <base-input alternative=""
                                label="Descuento actual"
                                input-classes="form-control-alternative"
                                v-model="accountInModal.discount"/>
                </div>
                <div class="col">
                    <label class="form-control-label">
                         Último pago bancario
                    </label>
                    <flat-pickr v-model="accountInModal.last_bank_payment_date" :config="{}" :disabled="!isSeller" class="form-control form-control-alternative" data-vv-as="Fecha" name="date" style="background-color: #FFFFFF"/>
                </div>
                <div class="col">
                    <input type="checkbox" class="form-check-input" v-model="accountInModal.payroll_same_bank">
                    <label class="form-control-label">Nómina en mismo banco</label>
                </div>
            </div>
            <div class="row" v-if="!isSeller">
                <div class="col">
                    <label class="form-control-label">
                         Fecha estimada
                    </label>
                    <flat-pickr v-model="accountInModal.will_pay_on" :config="{}" class="form-control form-control-alternative" data-vv-as="Fecha" name="date" style="background-color: #FFFFFF"/>
                </div>
                <div class="col">
                    <base-input alternative="" disabled
                                label="Liquidación esperada sin comisión"
                                input-classes="form-control-alternative"
                                v-model="accountInModal.will_pay_wo_fee"/>
                </div>
            </div>
             
            <div class="row d-flex align-items-center" v-if="!(isSeller || newAccount)">
                <div v-if="!accountInModal.paid_file" class="col">
                    <div class="card-profile-stats d-flex justify-content-center">
                        <dropbox text="" type="__" buttonText="Liquidar" :userid="client.id" :files="userFiles" v-on:uploadFile="setPaidAccount"/>
                    </div>
                </div>
                <div v-else class="col">
                    <div class="card-profile-stats d-flex justify-content-center img-center">
                        <img :src="accountInModal.fileulr" style="max-height: 200px">
                    </div>
                </div>
                <div class="col">
                    <label class="form-control-label">
                         Fecha de liquidación
                    </label>
                    <flat-pickr v-model="accountInModal.paid" :config="{}" class="form-control form-control-alternative" data-vv-as="Fecha" name="date" style="background-color: #FFFFFF"/>
                </div>
            </div>
            
            <template slot="footer">
                <div class="align-self-start mr-auto">
                    <base-button v-if="!newAccount && !prevDel && isAdmin" type="danger" v-on:click="prevDel=true">Eliminar cuenta</base-button>
                    <base-button v-if="!newAccount && prevDel" type="secondary" v-on:click="prevDel=false">Cancelar</base-button>
                </div>
                <base-button v-if="Number(client.balance) >= Number(accountInModal.discount) || !finamigo" type="success" v-on:click="settlementLetter">Solicitar carta de liquidación</base-button>
                <base-button v-if="!newAccount && prevDel && isAdmin" type="outline-danger" v-on:click="deleteAccount()">Confirmar eliminación</base-button>
                <base-button v-if="newAccount" type="primary" v-on:click="updateAccount(accountInModal)">Guardar    cuenta</base-button>
                <base-button v-if="!newAccount && !prevDel" type="primary" v-on:click="updateAccount(accountInModal)">Guardar cambios</base-button>
            </template>
             <div v-if="isAdmin">
                <account-tracing-table
                        title="Historial"
                        :data="accountTracingTableData"
                        :pagination="accountTracePagination"
                        v-on:pageSelected="accountTracePageSelected"
                        style="margin-top: 20px"
                />
            </div>
        </modal>

        <modal :show.sync="calcModal" v-on:close="calcModal=false" v-bind:large="true">
            <template slot="header">
                <h2 class="mb-0" id="calculatorModal" style="margin-top: 20px; margin-left: 10px">Calculadora de descuentos</h2>
            </template>
                <div v-if="calculos === dbmAccountsCalculations " class="row justify-content-center" style="margin-bottom: 20px">
                    <div class="col-lg-10">
                        <div class="row justify-content-center">
                            <div class="col-lg-5">
                                <card class="border-0" shadow body-classes="py-3">
                                    <div class="row justify-content-center">
                                        <div class="col">
                                            <h3 class="text-primary text-center">{{period}} meses</h3>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col">
                                            <base-slider :range="{min: 6, max: 48}" :options="{step: 1}" v-model.number="period" v-on:input="showCalcClick()"></base-slider>
                                        </div>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Total adeudado</h6>
                                        <span class="h2 font-weight-bold mb-0">${{formatDecPost(calculos.totalDebt).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-red text-white rounded-circle shadow">
                                            <i class="fas fa-money-bill"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Ahorros</h6>
                                        <span class="h2 font-weight-bold mb-0">${{formatDecPost(calculos.savings).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-success text-white rounded-circle shadow">
                                            <i class="fas fa-dollar-sign"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Duración del programa</h6>
                                        <span class="h2 font-weight-bold mb-0">{{calculos.period}} meses</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-info text-white rounded-circle shadow">
                                            <i class="fas fa-clock"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Depósito mensual</h6>
                                        <span class="h2 font-weight-bold mb-0">${{formatDecPost(calculos.monthlyFee ? calculos.monthlyFee : calculos.montlyFee).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-blue text-white rounded-circle shadow">
                                            <i class="fas fa-coins"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Descuento estimado</h6>
                                        <span class="h2 font-weight-bold mb-0">{{formatDecPost(calculos.discount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}%</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-warning text-white rounded-circle shadow">
                                            <i class="fa fa-percent"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Deudas</h6>
                                        <span class="h2 font-weight-bold mb-0">{{calculos && calculos.debts ? calculos.debts.length : "0"}}</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-indigo text-white rounded-circle shadow">
                                            <i class="fas fa-check"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-xl-10 col-lg-10 col-md-10">
                        <div class="card shadow">
                            <div class="card-header border-0">
                                <h3 class="mb-0">Deudas a liquidar</h3>
                            </div>
                            <div class="table-responsive">
                                <table class="table align-items-center table-flush">
                                    <thead class="thead-light">
                                    <tr>
                                        <th class="text-center" scope="col">Deuda</th>
                                        <th class="text-center" scope="col">Acreedor</th>
                                        <th class="text-center" scope="col">Deuda sin dbm</th>
                                        <th class="text-center" scope="col">Valor a pagar con dbm</th>
                                        <th class="text-center" scope="col">Mes a pagar</th>
                                        <th class="text-center" scope="col">Avance</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(debt, index) in calculos.debts" :key="index">
                                        <td class="text-center">
                                            {{index + 1}}
                                        </td>
                                        <td class="text-center">
                                            {{debt.bank}}
                                        </td>
                                        <td class="text-center">
                                            ${{formatDecPost(debt.amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                        </td>
                                        <td class="text-center">
                                            ${{debt.willPay ? formatDecPost(debt.willPay).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : formatDecPost(debt.will_pay).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                        </td>
                                        <td class="text-center">
                                            {{debt.willPayOnMonth ? debt.willPayOnMonth : debt.will_pay_on}}
                                        </td>
                                        <td class="text-center">{{formatDecPost(debt.o_progress)}}%
                                                <!--<div>
                                                    <div class="progress">
                                                        <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="47.7" aria-valuemin="0" aria-valuemax="100" v-bind="{style: debt.willPay / discount.totalDebt * 100}"></div>
                                                    </div>
                                                </div>-->
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            
            <template slot="footer">
                <base-button type="primary" v-on:click="calcModal=false">Cerrar</base-button>
            </template>
        </modal>
        
        <modal :show.sync="accountDetailsModal" v-on:close="accountDetailsModal=false" v-bind:large="true">
            <template slot="header">
                <h2 class="mb-0" id="accountDetModal" style="margin-top: 20px; margin-left: 10px">Detalles de la cuenta</h2>
                <!--div class="col text-right"><base-button size="sm" type="primary" v-on:click="moveAccount()">Mover cuenta</base-button></div-->
            </template>
            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Fecha de actualización</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FechaActualizacion}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-blue text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-day"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Regístro impugnado</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.RegistroImpugnado}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-cyan text-white rounded-circle shadow">
                                    <i class="fas fa-check"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Clave otorgante</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.ClaveOtorgante}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-yellow text-white rounded-circle shadow">
                                        <i class="fas fa-key"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Nombre otorgante</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.NombreOtorgante}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-gray text-white rounded-circle shadow">
                                        <i class="fas fa-university"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Cuenta actual</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.CuentaActual}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-teal text-white rounded-circle shadow">
                                        <i class="fas fa-credit-card"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Clave de unidad monetaria</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.ClaveUnidadMonetaria}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-purple  text-white rounded-circle shadow">
                                        <i class="fas fa-coins"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Valuación de valor activo</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.ValorActivoValuacion}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-orange text-white rounded-circle shadow">
                                        <i class="fas fa-balance-scale"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Número de pagos</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.NumeroPagos}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-green text-white rounded-circle shadow">
                                        <i class="fas fa-file-invoice-dollar"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Frecuencia de pagos</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FrecuenciaPagos}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-blue text-white rounded-circle shadow">
                                        <i class="fas fa-chart-bar"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Monto a pagar</h6>
                                    <span class="h2 font-weight-bold mb-0">${{formatDecPost(this.accountInModal.MontoPagar).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-red text-white rounded-circle shadow">
                                        <i class="fas fa-money-bill-alt"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Fecha de apertura de cuenta</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FechaAperturaCuenta}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-cyan text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-day"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Fecha de último pago</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FechaUltimoPago}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-teal text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-day"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Fecha de última compra</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FechaUltimaCompra}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-gray text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-day"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Fecha de cierre de cuenta</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FechaCierreCuenta}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-pink text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-day"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Garantía</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.Garantia}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-yellow text-white rounded-circle shadow">
                                        <i class="fas fa-award"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Crédito máximo</h6>
                                    <span class="h2 font-weight-bold mb-0">${{formatDecPost(this.accountInModal.CreditoMaximo).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-success text-white rounded-circle shadow">
                                        <i class="fas fa-hand-holding-usd"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Saldo actual</h6>
                                    <span class="h2 font-weight-bold mb-0">${{formatDecPost(this.accountInModal.SaldoActual).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-orange text-white rounded-circle shadow">
                                        <i class="fas fa-wallet"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Límite de crédito</h6>
                                    <span class="h2 font-weight-bold mb-0">${{formatDecPost(this.accountInModal.LimiteCredito).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-red text-white rounded-circle shadow">
                                        <i class="fas fa-dollar-sign"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Saldo vencido</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.SaldoVencido}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-purple text-white rounded-circle shadow">
                                        <i class="fas fa-coins"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Número de pagos vencidos</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.NumeroPagosVencidos}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-gray text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-times"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Pago actual</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.PagoActual}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-teal text-white rounded-circle shadow">
                                        <i class="fas fa-file-invoice-dollar"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Histórico pagos</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.HistoricoPagos}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-cyan text-white rounded-circle shadow">
                                        <i class="fas fa-history"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Fecha reciente de histórico pagos</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FechaRecienteHistoricoPagos}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-success text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-check"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Fecha antígua de histórico pagos</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FechaAntiguaHistoricoPagos}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-blue text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-check"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Clave de prevención</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.ClavePrevencion}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-pink text-white rounded-circle shadow">
                                        <i class="fas fa-key"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Total de pagos reportados</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.TotalPagosReportados}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-yellow text-white rounded-circle shadow">
                                        <i class="fas fa-plus-square"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Peor atraso</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.PeorAtraso}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-orange text-white rounded-circle shadow">
                                        <i class="fas fa-exclamation"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Fecha del peor atraso</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.FechaPeorAtraso}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-teal text-white rounded-circle shadow">
                                        <i class="fas fa-calendar-times"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5">
                    <div class="card card-stats mb-4 mb-xl-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-0">Saldo vencido peor atraso</h6>
                                    <span class="h2 font-weight-bold mb-0">{{this.accountInModal.SaldoVencidoPeorAtraso}}</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape bg-red text-white rounded-circle shadow">
                                        <i class="fas fa-dollar-sign"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="primary" v-on:click="accountDetailsModal=false">Cerrar</base-button>
            </template>
        </modal>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Dropbox from '../components/Dropbox'
    import BaseDropdown from '../components/BaseDropdown'
    import BaseSlider from '../components/BaseSlider'
    import FutureAccountsTable from './Tables/FutureAccountsTable'
    import AccountsTable from './Tables/AccountsTable'
    import AccountTracingTable from './Tables/AccountTracingTable'
    import PaymentsTable from './Tables/PaymentsTable'
    import PaymentPlanDebtsTable from './Tables/PaymentPlanDebtsTable'
    import CommissionsTable from './Tables/CommissionsTable'
    import UserFilesTable from './Tables/UserFilesTable'
    import UserStatusTracingTable from "./Tables/UserStatusTracingTable";
    import CreditReportTable from './Tables/CreditReportTable'
    import HistoryTable from './Tables/HistoryTable'
    import MovementsTable from './Tables/MovementsTable'
    export default {
        name: 'user-profile',
        components: {
            UserStatusTracingTable,
            AccountTracingTable,
            flatPickr,
            Dropbox,
            BaseDropdown,
            BaseSlider,
            FutureAccountsTable,
            AccountsTable,
            PaymentsTable,
            PaymentPlanDebtsTable,
            CommissionsTable,
            UserFilesTable,
            CreditReportTable,
            HistoryTable,
            MovementsTable
        },
        computed: {
            discount: {
                get () {
                    return this.newAccount ? this.accountInModal.amount : this.accountInModal.discount
                }
            },
            user() { return this.$getLS(this.$v.STORE_KEYS.USER) },
            mxStates() { return this.$store.state.mxStates },
            economicActivities() {
                let activities = this.$store.state.economicActivities
                if (!activities)
                    this.$store.dispatch('downloadEconomicActivities')
                return activities
            },
            sellers() { return this.$store.state.sellers },
            customerService() { return this.$store.state.customerService },
            banks() { return this.$store.state.banks },
            userTracingStatus() { return this.$store.state.userTraceStatus },
            leadStatus() { return this.$store.state.leadStatus },
            userActionsCatalog() { return this.$store.state.userActionsCatalog },
            userInactiveCatalog() { return this.$store.state.userInactiveCatalog }
        },
        created() {
            for(let i=0; i<this.userTracingStatus.length;i++){
                if(this.userTracingStatus[i].enabled)
                    this.userTracingStatusCatalog.push(this.userTracingStatus[i])
            }
            this.isAdmin = this.user.role === this.$v.ROLES.ADMIN
            this.isSeller = this.user.role === this.$v.ROLES.SELLER
            this.isService = this.user.role === this.$v.ROLES.SERVICE
            this.isManagerService = this.user.role === this.$v.ROLES.MANAGER_SERVICE
            let userId = this.$route.query.id
            if (userId > 0) {
                this.getClientProfile(userId).then(found => {
                    if (!found) {
                        this.$router.push("/clients")
                    }
                })
            }
        },
        watch: {
            $route () {
                let userId = this.$route.query.id
                if (userId > 0 )
                    this.getClientProfile(userId).then(found => {
                        if (!found) {
                            this.$router.push("/clients")
                        }
                    })
            }
        },
        data() {
            return {
                userTracingStatusCatalog: [],
                isAdmin: false,
                isSeller: false,
                isService: false,
                isManagerService: false,
                fileType: null,
                accountInModal: {},
                fileTypes: [ "ID", "ID_B", "ADDRESS", "CREDIT_INFO", "CONTRACT", "CURP", "FILE" ],
                newUserFileModal: false,
                newPayment: {},
                newCommission: {},
                selectedPayment: {},
                newPaymentModal: false,
                paymentModal: false,
                accountModal: false,
                accountDetailsModal: false,
                accountTraceTable: false,
                newAccount: false,
                clientPaymentResume: {},
                newCommissionModal: false,
                futureAccountModal: false,
//                paidAccountModal: false,
//                paidAccount: null,
                futureAccount: {
                    MontoPagar: 0,
                    LimiteCredito: 0,
                    FechaActualizacion: "",
                    FechaUltimoPago: ""
                },
                clientValidation: {
                    status: 2,
                    pin: 0
                },
                originalClient: {},
                originalBeneficiary: {},
                client: {},
                contract: {},
                userFiles: [],
                beneficiary: {},
                finamigo: {},
                files: {},
                paymentPagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                accountPagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                accountTracingTableData: [],
                accountTracePagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                commissionPagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                historyPagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                userFilesPagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                period: 12,
                paymentPlanDebts: [],
                paymentPlans: {},
                paymentPlan: {},
                tracingModal: false,
                newUserActionModal: false,
                statusTracingTableDataCS: [],
                statusTracingTableDataS: [],
                userActionsTableData: [],
                userInactiveTableData: [],
                statusTracingPaginationCS: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                tracingStatus: "",
                statusTracingPaginationS: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                userActionsPagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                userInactivePagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                movementsPagination: {
                    total: 0,
                    perPage: 5,
                    currentPage: 1
                },
                newTrace: {
                    id :0
                } ,
                futureAccountTableData: [],
                movementsTableData: [],
                paymentTableData: [],
                accountTableData: [],
                commissionTableData: [],
                userFilesTableData: [],
                historyTableData: [],
                stateOfBirth: null,
                postalCodes: [],
                sublocalities: [],
                locality: "",
                gender: null,
                beneficiaryGender: null,
                edit: false,
                tokenUrl: null,
                prevDel: false,
                showFinBalance: false,
                calcModal: false,
                sendMessageModal: false,
                dbmAccountsCalculations: {
                    totalDebt: 0,
                    savings: 0,
                    montlyFee: 0,
                    discount:0,
                    debts: []
                },
                clientCalculations: {
                    totalDebt: 0,
                    savings: 0,
                    montlyFee: 0,
                    discount:0,
                    debts: []
                },
                calculos: {
                    totalDebt: 0,
                    savings: 0,
                    montlyFee: 0,
                    discount:0,
                    debts: []
                },
                report: {},
                messageReport: "",
                lengthsCreditReports:{
                    dbmAccounts: null,
                    otherAccounts: null
                },
                pushNotTitle: "",
                theMessage: "",
                typeTheMessage: "",
                widthProgressBar: "",
                titleProgressBar: "",
                history: null,
                //showModalReport: null,
                pointer: 'pointer',
                pointer2: 'default',                
            }
        },
        methods: {
            async createFinamigoDocuments(typeDoc){
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.CREATE_FINAMIGO_DOCUMENTS
                this.$axios.post(url, {'user': this.client.id}).then((response) => {
                    this.$showLoader(false)
                    if (response.data.path) {
                        this.$notify({
                            text: "Creación exitosa",
                            type: 'success'
                        })
                        this.files[typeDoc] = 1
                        this.$forceUpdate()
                    } else {
                        this.$notify({
                            text: "Error al crear",
                            type: 'error'
                        })
                    }
                })
            },
            async uploadFinamigoFile(type) {
                if (this.files[type] && !this.files['upload_' + type]) {
                    this.$showLoader(true)
                    let url = this.$v.SERVER + this.$v.SELLER_OPS.UPLOAD_FILE_FINAMIGO
                    this.$axios.post(url, {
                        user: this.client.id,
                        type: type
                    }).then((response) => {
                        this.$showLoader(false)
                        let data = response.data
                        if (data[this.$v.API_SUCCESS]) {
                            this.$notify({
                                text: "Carga exitosa",
                                type: 'success'
                            })
                            this.files['upload_' + type] = 1
                            this.$forceUpdate()
                        } else {
                            this.$notify({
                                text: data[this.$v.API_ROW] !== null ? data[this.$v.API_ROW] : "Error desconocido",
                                type: 'error'
                            })
                        }
                    })
                } else if (!this.files[type] && !this.files['upload_' + type]) {
                    this.createFinamigoDocuments(type)
                }
            },
            async getFinamigoFiles() {
                let url = this.$v.SERVER + this.$v.OPS.GET_USER_FINAMIGO_FILES + "?user=" + this.client.id
                this.$axios.get(url).then((response) => {
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.files = response.data[this.$v.API_ROW]
                        this.$forceUpdate()
                    }
                })
            },
            getProgramCalculation() {
                let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_PROGRAM_CALCULATION + "?user=" + this.client.id
                this.$axios.get(url).then((response) => {
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        if (data.row['calculation']) {
                            this.clientCalculations = data.row['calculation']
                            this.$forceUpdate()
                        }
                    }
                    else
                        this.clientCalculations=null
                })
            },
            moveAccount(){
                this.accountDetailsModal = false
                let dbmAccTable = this.report['dbmAccounts']
                let otherAccTable = this.report['otherAccounts']
                let i = this.accountInModal.Index
                //Buscando en dbmAccounts
                if(dbmAccTable[i].CuentaActual === this.accountInModal.CuentaActual){
                    otherAccTable.push(dbmAccTable.splice(i,1)[0])
                }else if(otherAccTable[i].CuentaActual === this.accountInModal.CuentaActual){
                    dbmAccTable.push(otherAccTable.splice(i,1)[0])
                }
            },
            escEdit() {
                this.edit = false;
                this.getClientProfile(this.client.id)
            },
            getClientProfile(clientId) {
                return new Promise(resolve => {
                    let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_PROFILE + "?id=" + clientId
                    this.$axios.get(url).then((response) => {
                        let data = response.data
                        if (data[this.$v.API_SUCCESS]) {
                            this.client = response.data[this.$v.API_ROW]
                            this.loadClient()
                            resolve(true)
                        }
                        resolve(false)
                    })
                })
            },
            loadClient() {
                if (!this.client.hasOwnProperty('id')) this.edit = true
                else {
                    this.contract = {
                        user: this.client.id,
                        payday: this.client.payday,
                        program_duration: this.client.program_duration,
                        monthly_savings: this.client.monthly_savings,
                        commission_percentage: this.client.commission_percentage,
                        first_payment: this.client.first_payment,
                    }
                    if (this.client.beneficiary !== null) {
                        this.beneficiary = this.client.beneficiary
                        if (this.beneficiary.gender) {
                            if (this.beneficiary.gender === 'M')
                                this.beneficiaryGender = 'Masculino'
                            else if (this.beneficiary.gender === 'F')
                                this.beneficiaryGender = 'Femenino'
                        }
                        if (this.beneficiary.civil_status) {
                            if (this.beneficiary.civil_status === 'M')
                                this.beneficiary.civil_status = 'Casado'
                            else if (this.beneficiary.civil_status === 'S')
                                this.beneficiary.civil_status = 'Soltero'
                        }
                        this.originalBeneficiary = JSON.parse(JSON.stringify(this.beneficiary))
                        this.originalClient = JSON.parse(JSON.stringify(this.client))
                    }
                    if (this.client && this.client.gender !== undefined) {
                        if (this.client.gender === 'M')
                            this.gender = 'Masculino'
                        else if (this.client.gender === 'F')
                            this.gender = 'Femenino'
                    }
                    if (this.client.civil_status) {
                        if (this.client.civil_status === 'M')
                            this.client.civil_status = 'Casado'
                        else if (this.client.civil_status === 'S')
                            this.client.civil_status = 'Soltero'
                    }
                    if (this.client.state_of_birth) {
                        for (let i=0 ; i<this.mxStates.length ; i++) {
                            let st = this.mxStates[i]
                            if (this.client.state_of_birth === st.code) {
                                this.stateOfBirth = st.state
                                break
                            }
                        }
                    }
                    this.locality = this.client.locality
                    this.getTitleAndWidthProgressBar()
                    this.getClientPaymentResume()
                    this.getFinamigoFiles()
                    this.getCreditReport()
                    this.getProgramCalculation()
                    this.getHistoryEvent(1)
                    this.getTracingTableDataCS(1)
                    this.getTracingTableDataS(1)
                    this.getUserActionsTableData(1)
                    this.getUserInactiveTableData(1)
                    this.downloadField(this.$v.TABLES.FINAMIGO, 1, 1)
                    this.downloadField(this.$v.TABLES.ACCOUNTS, 1, 5)
                    this.getMovementsTableData(1)
                    this.downloadField(this.$v.TABLES.PAYMENTS, 1, 5)
                    this.downloadField(this.$v.TABLES.COMMISSIONS, 1, 5)
                    this.downloadField(this.$v.TABLES.USER_FILES, 1, 5)
                    if (!this.isSeller && this.client.contract > 0 && this.client.payment_count > 0) this.getFinamigoBalance()
                    this.$forceUpdate()
                }
            },
            showAccountInformationModal(acc) {
                this.futureAccount = acc
                this.futureAccountModal = true
            },
 /*           showPaidModal(acc) {
                this.paidAccount = acc
                this.paidAccountModal = true
            },*/
            requestValidationCode() {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.REQUEST_CREDIT_REPORT_PIN
                let request = {
                    user: this.client.id,
                    phone: this.client.phone
                }
                this.$axios.post(url, request).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        if (data[this.$v.API_ROW].validated)
                            this.clientValidation.status = 2
                        else
                            this.clientValidation.status = 1
                    } else {
                        this.$notify({
                            text: "Intenta nuevamente",
                            type: 'error'
                        })
                    }
                })
            },
            validateClient() {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.VALIDATE_CREDIT_REPORT_PIN
                let request = {
                    user: this.client.id,
                    pin: this.clientValidation.pin
                }
                this.$axios.post(url, request).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS])
                        this.clientValidation.status = 2
                    else
                        this.$notify({
                            text: "No se pudo validar, revisa los datos",
                            type: 'error'
                        })
                })
            },
            sendMessage(){
                this.$showLoader(true)
                let message = this.theMessage
                if(this.typeTheMessage==='SMS'){
                    let url = this.$v.SERVER + this.$v.SELLER_OPS.SEND_MESSAGE
                    this.$axios.post(url, {'user': this.client.id, 'message':message}).then(response => {
                        this.$showLoader(false)
                        if (response.data.success){
                            this.$notify({
                                text: "SMS enviado",
                                type: 'success'
                            })
                        } else {
                            this.$notify({
                                    text: "No se envió el SMS",
                                    type: 'error'
                                })
                        }
                    })
                } else if(this.typeTheMessage==="PN"){
                    let url = this.$v.SERVER + this.$v.SELLER_OPS.SEND_PUSH_NOTIFICATION
                    this.$axios.post(url, {'user':this.client.id, 'title':this.pushNotTitle, 'message':message}).then(response => {
                        this.$showLoader(false)
                        if (response.data.success){
                            this.$notify({
                                text: "Notification enviada",
                                type: 'success'
                            })
                        } else {
                            this.$notify({
                                    text: "No se envió la Notificación",
                                    type: 'error'
                                })
                        }
                    })
                }
            },
            requestSignatureToken(forContract) {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.CREATE_SIGNATURE_TOKEN + "?user=" + this.client.id
                if (forContract) {
                    url += '&for_contract=true'
                }
                this.$axios.get(url).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.$notify({
                            text: "Enlace enviado al cliente por SMS",
                            type: 'success'
                        })
                        /*let tokenEntry = data[this.$v.API_ROW]
                        if (tokenEntry.token) {
                            this.tokenUrl = this.$v.CLIENT_SERVER + this.$v.SIGNATURE_PATH + "?token=" + tokenEntry.token
                            if (forContract) {
                                this.tokenUrl += '&sign=contract'
                            }
                            this.$notify({
                                text: "Enlace enviado al cliente por SMS",
                                type: 'success'
                            })
                        } else {
                            this.$notify({
                                text: "Algo salió mal",
                                type: 'error'
                            })
                        }*/
                    } else {
                        switch (data[this.$v.API_REASON]) {
                            case 2:
                                this.$notify({
                                    text: "El cliente no está completo",
                                    type: 'error'
                                })
                                break;
                            default:
                                this.$notify({
                                    text: "Algo salió mal",
                                    type: 'error'
                                })
                                break;
                        }
                    }
                })
            },
            newFutureAccount() {
                this.futureAccountTableData.push({
                    bank: {},
                    account: "",
                    amount: 0.0,
                    editMode: true
                })
            },
            newAccountModal() {
               this.accountModal = true
               this.newAccount = true;
            },
            updateAccount() {
                if (!this.accountInModal.last_bank_payment_date && this.isSeller){
                    this.$notify({text: "Campos incompletos", type: 'warn'})
                    return 
                }
                console.log(this.accountInModal.payroll_same_bank);
                if (this.accountInModal.will_pay_on) this.accountInModal.will_pay_on += 'T12:00:00.000Z'
                else this.accountInModal.will_pay_on = null
                if (this.accountInModal.paid) this.accountInModal.paid += 'T12:00:00.000Z'
                else this.accountInModal.paid = null
                this.accountInModal.user = this.client.id
                this.accountInModal.contract = this.client.contract
                if (this.newAccount) this.accountInModal.discount = this.discount
                let url = this.$v.SERVER + this.$v.SELLER_OPS.UPDATE_ACCOUNTS
                console.log(this.accountInModal)
                this.$showLoader(true)
                this.$axios.post(url, { accounts: [this.accountInModal]}).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.downloadField(this.$v.TABLES.ACCOUNTS, 1, 5)
                        this.$notify({
                            text: "Actualizado correctamente",
                            type: 'success'
                        })
                    } else {
                        this.$notify({
                            text: "Algo salió mal, intenta nuevamente",
                            type: 'error'
                        })
                    }
                })
                this.accountModal = false
                this.newAccount = false
                this.accountInModal = {}
            },
            accountPageSelected(page) {
                this.downloadField(this.$v.TABLES.ACCOUNTS, page, this.accountPagination.perPage)
            },
            accountTracePageSelected(page) {
                this.downloadField(this.$v.TABLES.ACCOUNTS_TRACING, page, this.accountTracePagination.perPage, "account=" + this.accountInModal.id)
            },
            paymentPageSelected(page) {
                this.downloadField(this.$v.TABLES.PAYMENTS, page, this.paymentPagination.perPage)
            },
            commissionPageSelected(page) {
                this.downloadField(this.$v.TABLES.COMMISSIONS, page, this.commissionPagination.perPage)
            },
            userFilesPageSelected(page) {
                this.downloadField(this.$v.TABLES.USER_FILES, page, this.userFilesPagination.perPage)
            },
            formatDate(date) {
                return this.$formatDate(date)
            },
            tabSelected(tab) {
                if (tab.id === "calculator") {
                    this.paymentPlans = {}
                    if (this.futureAccountTableData.length > 0) {
                        for (let i=0 ; i<this.futureAccountTableData.length ; i++) {
                            let acc = this.futureAccountTableData[i]
                            let bank = acc.bank
                            if (acc.amount < 1000 || bank === undefined || bank === null || !bank.hasOwnProperty('id') || bank['id'] < 1) {
                                this.$notify({
                                    text: "Algunas cuentas tienen error, revisalas antes de continuar",
                                    type: 'error'
                                })
                                return
                            }
                        }
                        this.requestPaymentPlan()
                    }
                }
            },
            requestPaymentPlan(period) {
                if (period) this.period = period
                let request = {
                    name: this.client.name,
                    lastname: this.client.lastname_1,
                    period: this.period,
                    debts: this.futureAccountTableData
                }
                if (this.paymentPlans.hasOwnProperty(String(this.period))) {
                    this.paymentPlan = this.paymentPlans[String(this.period)]
                    this.client.monthly_savings = this.formatDecPost(this.paymentPlan.montlyFee)
                    this.client.program_duration = this.period
                    return
                }
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.OPS.CALCULATE
                this.$axios.post(url, request).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data.success) {
                        this.paymentPlans[String(this.period)] = data.row
                        this.paymentPlan = data.row
                        this.client.monthly_savings = this.formatDecPost(this.paymentPlan.montlyFee)
                        this.client.program_duration = this.period
                    }
                })
            },
            downloadField(field, page, limit, query) {
                let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_USER_FIELDS + "?user=" + this.client.id + "&model=" + field
                          + "&offset=" + limit*(page - 1) + "&limit=" + limit
                if (query)
                    url += "&" + query
                this.$axios.get(url).then(response => {
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        let p = data[this.$v.API_ROW]
                        let a = data[this.$v.API_ROWS]
                        switch (field) {
                            case this.$v.TABLES.ACCOUNTS:
                                for (let i=0 ; i<a.length ; i++) {
                                    for (let j=0 ; j<this.banks.length ; j++) {
                                        if (this.banks[j].id === a[i].bank) {
                                            a[i].bank = this.banks[j]
                                            break
                                        }
                                    }
                                }
                                this.accountTableData = a
                                this.accountPagination.total = p['totalItems']
                                this.accountPagination.currentPage = page
                                this.accountPagination.perPage = limit
                                break
                            case this.$v.TABLES.PAYMENTS:
                                this.paymentTableData = data[this.$v.API_ROWS]
                                this.paymentPagination.total = p['totalItems']
                                this.paymentPagination.currentPage = page
                                this.paymentPagination.perPage = limit
                                break
                            case this.$v.TABLES.COMMISSIONS:
                                this.commissionTableData = data[this.$v.API_ROWS]
                                this.commissionPagination.total = p['totalItems']
                                this.commissionPagination.currentPage = page
                                this.commissionPagination.perPage = limit
                                break
                            case this.$v.TABLES.USER_FILES:
                                this.userFilesTableData = data[this.$v.API_ROWS]
                                this.userFilesPagination.total = p['totalItems']
                                this.userFilesPagination.currentPage = page
                                this.userFilesPagination.perPage = limit
                                break
                            case this.$v.TABLES.FINAMIGO:
                                this.finamigo = data[this.$v.API_ROWS][0]
                                break
                            case this.$v.TABLES.ACCOUNTS_TRACING:
                                this.accountTracingTableData = data[this.$v.API_ROWS]
                                console.log(this.accountTracingTableData)
                                break
                        }
                        this.$forceUpdate()
                    } else {
                        this.$validateSession(data)
                    }
                })
            },
            calculateRFC_CURP() {
                let params = {
                    name: this.client.name,
                    lastname_1: this.client.lastname_1,
                    lastname_2: this.client.lastname_2,
                    state: this.client.state_of_birth,
                    birthday: this.client.birthday,
                    gender: this.client.gender.substring(0, 1)
                }
                let keys = Object.keys(params)
                let url = this.$v.SERVER + this.$v.OPS.GET_RFC_CURP + '?'
                for (let k=0 ; k<keys.length ; k++)
                    url += keys[k] + '=' + params[keys[k]] + '&'
                this.$axios.get(url).then(response => {
                    let data = response.data
                    if (data.hasOwnProperty('RFC'))
                        this.client.rfc = data['RFC']
                    if (data.hasOwnProperty('CURP'))
                        this.client.curp = data['CURP']
                    this.$forceUpdate()
                })
            },
            uploadChanges() {
                if (!this.$_.isEqual(this.client, this.originalClient) ||
                    !this.$_.isEqual(this.beneficiary, this.originalBeneficiary)) {
                    let clientToUpload = JSON.parse(JSON.stringify(this.$v.OBJECTS.USER))
                    for (let key in clientToUpload)
                        if (clientToUpload.hasOwnProperty(key) && this.client.hasOwnProperty(key))
                            clientToUpload[key] = this.client[key]
                    if (this.client.civil_status) {
                        clientToUpload.civil_status = this.client.civil_status.substring(0, 1).toUpperCase()
                        if (clientToUpload.civil_status !== 'S')
                            clientToUpload.civil_status = 'M'
                    }
                    let beneficiary = JSON.parse(JSON.stringify(this.beneficiary))
                    if (Object.keys(beneficiary).length > 0) {
                        beneficiary.civil_status = this.beneficiary.civil_status.substring(0, 1).toUpperCase()
                        if (beneficiary.civil_status !== 'S')
                            beneficiary.civil_status = 'M'
                        beneficiary.user = this.client.id
                        beneficiary.gender = this.beneficiaryGender.substring(0, 1).toUpperCase()
                        if (beneficiary.gender !== 'M')
                            beneficiary.gender = 'F'
                        beneficiary.user = this.client.id
                    } else { beneficiary = null }
                    let url = this.$v.SERVER + this.$v.SELLER_OPS.UPDATE_USER
                    this.$showLoader(true)
                    this.$axios.post(url, clientToUpload).then(response => {
                        this.$showLoader(false)
                        let data = response.data
                        if (data[this.$v.API_SUCCESS]) {
                            if (beneficiary) {
                                if (this.client.id > 0) {
                                    beneficiary.user = this.client.id
                                } else {
                                    beneficiary.user = data[this.$v.API_ROW].id
                                }
                                url = this.$v.SERVER + this.$v.SELLER_OPS.UPDATE_BENEFICIARY
                                this.$showLoader(true)
                                this.$axios.post(url, beneficiary).then(response => {
                                    this.$showLoader(false)
                                    let data = response.data
                                    if (!data[this.$v.API_SUCCESS]) {
                                        if (data[this.$v.API_REASON] === 10) {
                                            this.$notify({
                                                text: "Usuario duplicado, contacta con el administrador",
                                                type: 'error'
                                            })
                                        } else {
                                            this.$notify({
                                                text: "Intenta nuevamente",
                                                type: 'error'
                                            })
                                        }
                                    } else {
                                        this.$notify({
                                            text: "Actualizado",
                                            type: "success"
                                        })
                                        this.edit = false
                                    }
                                })
                            } else {
                                this.$showLoader(false)
                                let data = response.data
                                if (!data[this.$v.API_SUCCESS]) {
                                    this.$notify({
                                        text: "Intenta nuevamente",
                                        type: 'error'
                                    })
                                } else {
                                    this.$notify({
                                        text: "Actualizado",
                                        type: "success"
                                    })
                                    this.edit = false
                                }
                            }
                        } else {
                            this.$notify({
                                text: "Intenta nuevamente",
                                type: 'error'
                            })
                        }
                    })

                } else this.edit = false
            },
            uploadFile(obj) {
                let fileType = obj.type
                let file = obj.file
                let text = obj.text
                let formData = new FormData();
                formData.append("file", file);
                let headers = {
                    "client-id": this.client.id,
                    "file-type": fileType
                }
                this.$showLoader(true)
                this.$axios.post(this.$v.SERVER + this.$v.SELLER_OPS.UPLOAD_FILE, formData, {headers: headers}).then(response => {
                    this.$showLoader(false)
                    if (response.data.success) {
                        this.newUserFileModal = false
                        this.fileType = null
                        this.downloadField(this.$v.TABLES.USER_FILES, 1, 5)
                        this.$notify({
                            text: text + " cargado exitosamente",
                            type: 'success'
                        })
                    } else {
                        this.$notify({
                            text: "No se logró cargar " + text,
                            type: 'warn'
                        })
                    }
                }).catch(e => {
                    console.log(e)
                    this.$showLoader(false)
                    alert("No se logró subir, intente nuevamente")
                })
            },
            setPaidAccount(obj) {
                let file = obj.file
                console.log("S3File")
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_PRESIGNED_PUT_OBJECT_URL + "?user=" + this.client.id + "&filename=" + file.name
                this.$axios.get(url).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        let signedUrl = data[this.$v.API_ROW]
                        this.$showLoader(true)
                        this.$axios.put(signedUrl, file, {headers: {}}).then(putObjectResponse => {
                            this.$showLoader(false)
                            console.log(putObjectResponse)
                            if (putObjectResponse.status === 200) {
                                let updateUrl = this.$v.SERVER + this.$v.SERVICE_OPS.SET_PAID_ACCOUNT
                                let request = {
                                    user: this.client.id,
                                    paid_file: file.name,
                                    account_id: this.accountInModal.id,
                                    paid: Date()
                                }
                                //console.log(request);
                                this.$axios.post(updateUrl, request).then(response => {
                                    let data = response.data
                                    //console.log(data);
                                    if (data[this.$v.API_SUCCESS]) {
                                        this.$notify({
                                            text: "Cuenta liquidada",
                                            type: 'success'
                                        })
                                        this.accountInModal.paid_file = file.name
                                        //console.log(this.accountInModal.paid_file);
                                        this.downloadField(this.$v.TABLES.ACCOUNTS, 1, 5)
                                    } else {
                                        this.$notify({
                                            text: "No se logró liquidar la cuenta",
                                            type: 'warn'
                                        })
                                    }
                                })
                            } else {
                                this.$notify({
                                    text: "No se logró liquidar la cuenta",
                                    type: 'warn'
                                })
                            }
                        }).catch(err => {
                            console.log(err)
                            this.$notify({
                                text: "No se logró liquidar la cuenta",
                                type: 'warn'
                            })
                        })
                    } else {
                        this.$notify({
                            text: "No se logró marcar como liquidada ",
                            type: 'warn'
                        })
                    }
                })
            },
            uploadPayment(obj) {
                let file = obj.file
                let text = obj.text
                let formData = new FormData();
                formData.append("file", file);
                let headers = {
                    "client-id": this.client.id,
                    "amount": this.newPayment.amount,
                    "payment-date": this.newPayment.date + 'T12:00:00.000Z'
                }
                this.$showLoader(true)
                this.$axios.post(this.$v.SERVER + this.$v.SELLER_OPS.UPLOAD_PAYMENT, formData, {headers: headers}).then(response => {
                    this.$showLoader(false)
                    if (response.data.success) {
                        this.newPaymentModal = false
                        this.newPayment = {}
                        this.downloadField(this.$v.TABLES.PAYMENTS, 1, 5)
                        this.$notify({
                            text: text + " cargado exitosamente",
                            type: 'success'
                        })
                    } else {
                        this.$notify({
                            text: "No se logró cargar " + text,
                            type: 'warn'
                        })
                    }
                }).catch(e => {
                    console.log(e)
                    this.$showLoader(false)
                    alert("No se logró subir, intente nuevamente")
                })
            },
            uploadContract() {
                this.$showLoader(true)
                let contract = {
                    user: this.client.id,
                    payday: this.client.payday,
                    program_duration: this.client.program_duration,
                    monthly_savings: this.client.monthly_savings,
                    commission_percentage: this.client.commission_percentage,
                    first_payment: this.client.first_payment
                }
                if (this.client.contract > 0) {
                    contract.id = this.client.contract
                }
                let url = this.$v.SERVER + this.$v.SELLER_OPS.CREATE_CONTRACT
                this.$axios.post(url, contract).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.contract = contract
                        let _contract = data[this.$v.API_ROW]
                        if (this.client.contract === 0) {
                            this.client.contract = _contract[0].id
                        }
                        this.$forceUpdate()
                        this.$notify({
                            text: "Exitoso",
                            type: 'success'
                        })
                    } else {
                        this.$notify({
                            text: "Algo salió mal, intenta nuevamente",
                            type: 'error'
                        })
                    }
                })
            },
            setGender(gender) {
                this.client.gender = gender.substring(0, 1).toUpperCase()
                this.gender = gender
                this.$forceUpdate()
                this.calculateRFC_CURP()
            },
            setBeneficiaryGender(gender) {
                this.beneficiary.gender = gender.substring(0, 1).toUpperCase()
                this.beneficiaryGender = gender
                this.$forceUpdate()
            },
            setCivilStatus(isUser, status) {
                if (isUser) {
                    this.client.civil_status = status
                }
            },
            setMxState(state) {
                this.client.state_of_birth = state.code
                this.stateOfBirth = state.state
                this.$forceUpdate()
                this.calculateRFC_CURP()
            },
            setEconomicActivity(activity) {
                this.client.economic_activity = activity
                this.$forceUpdate()
            },
            getEconomicActivity() {
                for (let i=0 ; i<this.economicActivities.length ; i++)
                    if (this.economicActivities[i].id === this.client.economic_activity)
                        return this.economicActivities[i].activity
                return null
            },
            postalCodeUpdated(pcode) {
                if (pcode.length > 3) {
                    let url = this.$v.SERVER + this.$v.OPS.GET_POSTAL_CODE + '?pc=' + pcode
                    this.$axios.get(url).then(response => {
                        let data = response.data
                        if (data[this.$v.API_SUCCESS]) {
                            this.postalCodes = data[this.$v.API_ROWS]
                            if (this.postalCodes.length === 1)
                                this.postalCodeSelected(this.postalCodes[0])
                            this.$forceUpdate()
                        }
                    })
                } else {
                    this.postalCodes = []
                    this.locality = ""
                    this.sublocalities = []
                    this.client.addr_sublocality = ""
                }
            },
            postalCodeSelected(postalCode) {
                this.client.addr_postal_code = postalCode.postal_code
                this.sublocalities = postalCode['sublocality'].split(';')
                if (this.sublocalities.length === 1)
                    this.client.addr_sublocality = this.sublocalities[0]
                this.locality = postalCode['locality']
            },
            formatDecPost(val, pos) {
                if (!pos)
                    pos = 2
                if (val && Number(val))
                    return Number(val).toFixed(pos)
                return "0.00"
            },
            getFileType(type) {
                switch (type) {
                    case 'FILE': return "Otro"
                    case 'ID': return "Identificación frente"
                    case 'ID_B': return "Identificación reverso"
                    case 'CURP': return "CURP"
                    case 'ADDRESS': return "Comprobante domicilio"
                    case 'CREDIT_INFO': return "Reporte de crédito"
                    case 'CONTRACT': return "Contrato firmado"
                    case 'FIN_CONTRACT': return "Contrato apertura de cuenta"
                    case 'FIN_MANIFEST': return "Carátula de apertura de cuenta"
                }
                return ""
            },
            getFileUrl(userid) {
                let session = JSON.parse(localStorage.getItem(this.$v.STORE_KEYS.SESSION))
                if (session) {
                    let url=this.$v.SERVER + this.$v.SELLER_OPS.GET_USER_FILE + "?user=" + userid + "&filename=" +
                        this.accountInModal.paid_file /*+ "&redirect=true"*/ + "&session=" + session[this.$v.SESSION]
                    this.$axios.get(url).then(response => {
                        this.accountInModal.fileulr = response.data
                    }) 
                }
            },
            getPaymentFile(id) {
                if (id) {
                    let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_USER_PAYMENT_FILE + "?id=" + id
                    this.$axios.get(url).then(response => {
                        this.selectedPayment.fileurl = response.data
                        this.$forceUpdate()
                    })
                }
            },
            onPaymentSelected(payment) {
                this.selectedPayment = payment
                this.paymentModal = true
            },
            updatePayment(setPayment) {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.UPDATE_PAYMENT
                let request
                if(setPayment){
                    request = {
                        id: this.selectedPayment.id,
                        amount: this.selectedPayment.amount,
                        created: this.selectedPayment.created
                    }
                }else{
                    request = {
                        id: this.selectedPayment.id,
                        validated: !this.selectedPayment.validated
                    }
                }
                this.$axios.post(url, request).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.$notify({
                            text: "Actualizado exitosamente",
                            type: 'success'
                        })
                        this.selectedPayment.validated = !this.selectedPayment.validated
                        this.$forceUpdate()
                    } else {
                        this.$notify({
                            text: "No se logró actualizar",
                            type: 'error'
                        })
                    }
                })
            },
            createFinamigoAccount() {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.CREATE_FINAMIGO_ACCOUNT
                this.$axios.post(url, {user: this.client.id}).then(response => {
                    let data = response.data
                    this.$showLoader(false)
                    if (data[this.$v.API_SUCCESS]) {
                        this.$notify({
                            text: "Creado exitosamente",
                            type: 'success'
                        })
                        this.downloadField(this.$v.TABLES.USER_FILES, 1, 5)
                        this.downloadField(this.$v.TABLES.FINAMIGO, 1, 1)
                    } else {
                        this.$notify({
                            text: "No se logró crear",
                            type: 'error'
                        })
                    }
                })
            },
            createCommission() {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.CREATE_COMMISSION
                let request = {
                    user: this.client.id,
                    date: this.newCommission.date + 'T12:00:00.000Z',
                    amount: this.newCommission.amount,
                }
                if (request.user && request.date && request.amount > 0) {
                    this.$axios.post(url, request).then(response => {
                        this.$showLoader(false)
                        let data = response.data
                        if (data[this.$v.API_SUCCESS]) {
                            this.$notify({
                                text: "Creado exitosamente",
                                type: 'success'
                            })
                            this.newCommissionModal = false
                            this.newCommission = {}
                            this.downloadField(this.$v.TABLES.COMMISSIONS, 1, 5)
                        } else {
                            this.$notify({
                                text: "No se logró crear",
                                type: 'error'
                            })
                        }
                    })
                } else {
                    this.$showLoader(false)
                    this.$notify({
                        text: "Llena el monto y la fecha para continuar",
                        type: 'error'
                    })
                }
            },
            sublocalitySelected(sublocality){
                this.client.addr_sublocality = sublocality
                this.$forceUpdate()
            },
            clientCivilStatusSelected(civiStatus) {
                this.client.civil_status = civiStatus
                this.$forceUpdate()
            },
            beneficiaryCivilStatusSelected(civiStatus) {
                this.beneficiary.civil_status = civiStatus
                this.$forceUpdate()
            },
            changeNewPaymentValidation() {
                this.newPayment.validated = !this.newPayment.validated
                this.$forceUpdate()
            },
            resetPassword() {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.RESET_USER_PASSWORD
                this.$axios.post(url, {user: this.client.id}).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.$notify({
                            text: "Contraseña actualizada exitosamente",
                            type: 'success'
                        })
                    } else {
                        this.$notify({
                            text: "No se logró actualizar",
                            type: 'error'
                        })
                    }
                })
            },
            updatePaymentStatus() {
                let status = this.client.program_status
                if (status === 1) {
                    status = -1
                } else { status += 1 }
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.UPDATE_USER_PAYMENT_STATUS
                this.$axios.post(url, {
                    user: this.client.id,
                    contract: this.client.contract,
                    program_status: status
                }).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.client.program_status = status
                        this.$forceUpdate()
                        this.$notify({
                            text: "Contraseña actualizada exitosamente",
                            type: 'success'
                        })
                    } else {
                        this.$notify({
                            text: "No se logró actualizar",
                            type: 'error'
                        })
                    }
                })
            },
            hasCompleteProfile() {
                var isComplete = this.client.id &&
                this.client.lastname_1 &&
                this.client.lastname_2 &&
                this.client.name &&
                this.client.birthday &&
                this.client.civil_status &&
                this.client.gender &&
                this.client.addr_sublocality &&
                this.client.addr_street &&
                this.client.addr_postal_code &&
                this.client.phone &&
                this.client.state_of_birth &&
                this.client.curp &&
                this.client.rfc &&
                this.client.economic_activity &&
                this.accountTableData.length > 0 &&

                this.beneficiary.lastname_1 &&
                this.beneficiary.lastname_2 &&
                this.beneficiary.name &&
                this.beneficiary.birthday &&
                this.beneficiary.civil_status &&
                this.beneficiary.gender
                if (isComplete !== undefined && isComplete !== null) {
                    switch (typeof isComplete) {
                        case 'string':
                        case 'object':
                            return isComplete.length > 0
                        case 'boolean':
                            return isComplete
                        default:
                            return false
                    }
                }
                return false
            },
            canRequestCreditReport() {
                if (this.client.has_signature && this.client.for_credit_report)
                    return false
                if (this.finamigo && this.finamigo.account && this.finamigo.account.length > 0)
                    return false
                let b = this.client.id &&
                    this.client.lastname_1 &&
                    this.client.lastname_2 &&
                    this.client.name &&
                    this.client.birthday &&
                    this.client.addr_sublocality &&
                    this.client.addr_street &&
                    this.client.addr_postal_code &&
                    this.client.phone &&
                    this.client.curp &&
                    this.client.rfc
                let id = false
                let id_b = false
                for (let i = 0 ; i<this.userFiles.length ; i++) {
                    let file = this.userFiles[i]
                    if (file.type === 'ID')
                        id = true
                    if (file.type === 'ID_B')
                        id_b = true
                }
                return b && id && id_b
            },
            createDBMenosContract() {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.CREATE_DBM_CONTRACT
                this.$axios.post(url, {user: this.client.id}).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.$notify({
                            text: "Contrato creado exitosamente",
                            type: 'success'
                        })
                        this.downloadField(this.$v.TABLES.USER_FILES, 1, 5)
                    } else {
                        this.$notify({
                            text: "No se logró crear el contrato",
                            type: 'error'
                        })
                    }
                })
            },
            canCreateDBMContract() {
                if (this.client && this.client.hasOwnProperty('dbm_contract')) {
                    if (this.client.dbm_contract === 1 && !this.isAdmin)
                        return false
                    let completeProfile = this.hasCompleteProfile()
                    return (completeProfile &&
                        this.finamigo !== undefined &&
                        this.finamigo !== null &&
                        this.finamigo.hasOwnProperty("account") &&
                        this.finamigo.account.length > 0)
                }
                return false
            },
            uploadTrace() {
                if (this.newTrace === undefined || this.newTrace.comments === "" || this.newTrace.status === 0) {
                    this.$notify({
                        text: "Datos incompletos",
                        type: 'warn'
                    })
                    return
                }
                let json = {
                    user: this.client.id,
                    comments: this.newTrace.comments
                }
                if (this.tracingStatus === "Inactivar programa") Object.assign(json, {value: this.newTrace.statusId})
                else if (this.tracingStatus === "Acciones cliente") Object.assign(json, {action: this.newTrace.statusId})
                else Object.assign(json, {status: this.newTrace.statusId})
                let setType = this.tracingStatus === "Inactivar programa" ? this.$v.CONSULTANT_OPS.SET_INACTIVE_USER : this.tracingStatus === "Acciones cliente" ? this.$v.CONSULTANT_OPS.SET_USER_ACTION : this.tracingStatus === "Seguimiento de ventas" ? this.$v.SELLER_OPS.SET_SELL_TRACING : this.$v.SERVICE_OPS.SET_USER_TRACING
                let url =   this.$v.SERVER + setType
                this.$showLoader(true)
                this.$axios.post(url, json).then(response => {
                    this.$showLoader(false)
                    if (response.data[this.$v.API_SUCCESS]) {
                        this.$notify({
                            text: "Carga exitosa",
                            type: 'success'
                        })
                        this.tracingModal = false
                        this.newTrace = {
                            id: 0
                        }
                        if(this.tracingStatus === "Inactivar programa") this.getUserInactiveTableData(1)
                        else if(this.tracingStatus === "Acciones cliente") this.getUserActionsTableData(1)
                        else if(this.tracingStatus === "Seguimiento de ventas") this.getTracingTableDataS(1)
                        else this.getTracingTableDataCS(1)
                    } else {
                        this.$notify({
                            text: "Falló la carga",
                            type: 'error'
                        })
                    }
                })
            },
            setTraceStatus(status) {
                this.newTrace.statusId = status.id
                this.newTrace.status = status.status ? status.status : status.value
                this.$forceUpdate()
            },
            closeAccountModal() {
                this.accountModal = false
                this.newAccount = false
                this.accountInModal = {}
                this.prevDel = false
            },
            getBank(id) {
                for (let i=0 ; i<this.banks.length ; i++)
                    if (this.banks[i].id === id)
                        return this.banks[i]
                return null
            },
            setBankInAccount(bank) {
                this.accountInModal.bank = bank.id
                this.$forceUpdate()
            },
            accountClick(acc){
                this.accountDetailsModal = true
                this.accountInModal = {
                    FechaActualizacion: acc.FechaActualizacion,
                    RegistroImpugnado: acc.RegistroImpugnado,
                    ClaveOtorgante: acc.ClaveOtorgante,
                    NombreOtorgante: acc.NombreOtorgante,
                    CuentaActual: acc.CuentaActual,
                    //TipoResponsabilidad: acc.TipoResponsabilidad.name,
                    //TipoCuenta: acc.TipoCuenta.name,
                    //TipoCredito: acc.TipoCredito.name,
                    ClaveUnidadMonetaria: acc.ClaveUnidadMonetaria,
                    ValorActivoValuacion: acc.ValorActivoValuacion,
                    NumeroPagos: acc.NumeroPagos,
                    FrecuenciaPagos: acc.FrecuenciaPagos,
                    MontoPagar: acc.MontoPagar,
                    FechaAperturaCuenta: acc.FechaAperturaCuenta,
                    FechaUltimoPago: acc.FechaUltimoPago,
                    FechaUltimaCompra: acc.FechaUltimaCompra,
                    FechaCierreCuenta: acc.FechaCierreCuenta,
                    FechaReporte: acc.FechaReporte,
                    UltimaFechaSaldoCero: acc.UltimaFechaSaldoCero,
                    Garantia: acc.Garantia,
                    CreditoMaximo: acc.CreditoMaximo,
                    SaldoActual: acc.SaldoActual,
                    LimiteCredito: acc.LimiteCredito,
                    SaldoVencido: acc.SaldoVencido,
                    NumeroPagosVencidos: acc.NumeroPagosVencidos,
                    PagoActual: acc.PagoActual,
                    HistoricoPagos: acc.HistoricoPagos,
                    FechaRecienteHistoricoPagos: acc.FechaRecienteHistoricoPagos,
                    FechaAntiguaHistoricoPagos: acc.FechaAntiguaHistoricoPagos,
                    ClavePrevencion: acc.ClavePrevencion,
                    TotalPagosReportados: acc.TotalPagosReportados,
                    PeorAtraso: acc.PeorAtraso,
                    FechaPeorAtraso: acc.fechapeoratraso,
                    SaldoVencidoPeorAtraso: acc.SaldoVencidoPeorAtraso,
                    //Banco: acc.bank.getBank(acc.bank).name,
                    Index: acc.accountsTableIndex
                }
            },
            accountSelected(acc) {
                this.accountModal = true
                this.newAccount = false
                this.accountInModal = {
                    bank : acc.bank.id,
                    account : acc.account,
                    amount : acc.amount,
                    discount : acc.discount,
                    index : acc.accountsTableIndex,
                    id : acc.id,
                    payroll_same_bank: acc.payroll_same_bank,
                    last_bank_payment_date: this.$moment(acc.last_bank_payment_date).add(1,'d')._d,
                    will_pay : acc.will_pay,
                    will_pay_wo_fee : acc.will_pay_wo_fee,
                    will_pay_on : acc.will_pay_on,
                    paid_file : acc.paid_file,
                    fileulr: null,
                    paid : acc.paid
                }
                if(this.accountInModal.paid_file)
                    this.getFileUrl(acc.user)
          /*     if (acc.will_pay)
                   this.accountInModal.will_pay = acc.will_pay
               if (acc.will_pay_on)
                   this.accountInModal.will_pay_on = acc.will_pay_on*/
            },
            deleteAccount(){
                let url = this.$v.SERVER + this.$v.ADMIN_OPS.DELETE_ACCOUNT
                this.$showLoader(true)
                this.$axios.post(url, {id:this.accountInModal.id}).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.downloadField(this.$v.TABLES.ACCOUNTS, 1, 5)
                        this.$notify({
                            text: "Cuenta eliminada correctamente",
                            type: 'success'
                        })
                        this.closeAccountModal()
                    } else {
                        this.$notify({
                            text: "Algo salió mal, intenta nuevamente",
                            type: 'error'
                        })
                    }
                })
            },
            getFinamigoBalance(){
                let url = this.$v.SERVER + this.$v.OPS.GET_FINAMIGO_BALANCE + "?user=" + this.client.id
                this.$showLoader(true)
                this.$axios.get(url).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.client.finamigoBalance = data.row.balance
                        this.$forceUpdate()
                    }
                })
                this.showFinBalance = true
            },
            getConsultantName(id) {
                for (let i=0 ; i<this.sellers.length ; i++)
                    if (this.sellers[i].id === id) return this.sellers[i].name + " " + this.sellers[i].lastname_1
                for (let i=0 ; i<this.customerService.length ; i++)
                    if (this.customerService[i].id === id) return this.customerService[i].name + " " + this.customerService[i].lastname_1
                return "- - -"
            },
            settlementLetter(){
                let url = this.$v.SERVER + this.$v.SELLER_OPS.REQUEST_ACCOUNT_SIGN + "?user=" + this.client.id + "&account=" + this.accountInModal.id
                this.$showLoader(true)
                this.$axios.get(url).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.$notify({
                            text: "Firma para liquidación solicitada exitosamente",
                            type: 'success'
                        })
                        this.closeAccountModal()
                    } else {
                        this.$notify({
                            text: "Algo salió mal. Intenta nuevamente",
                            type: 'error'
                        })
                    }
                })
            },
            iconoFinAmigo(icono, enDBm, enFinA) {
                let color = null
                if (!enDBm) {
                    color = "text-danger"
                } else if (!enFinA && enDBm) {
                    color = "text-info"
                } else if (enFinA && enDBm) {
                    color = "text-success"
                }
                return icono + " " + color
            },
            updateCreditReport(){
                this.$showLoader(true)
                let user = this.client
                let url = this.$v.SERVER + this.$v.SELLER_OPS.UPDATE_CREDIT_REPORT+ "?user=" + user.id
                this.$axios.get(url).then(response => {
                    this.$showLoader(false)
                    if (response.data.success){
                        this.getCreditReport()
                        this.$notify({
                            text: "Actualizado exitosamente",
                            type: 'success'
                        })
                    } else {
                        this.$notify({
                                text: "No es posible actualizar",
                                type: 'error'
                            })
                    }
                })
            },
            getCreditReport() {
                let url = this.$v.SERVER + this.$v.SERVICE_OPS.GET_CREDIT_REPORT + "?user=" + this.client.id
                this.$showLoader(true)
                this.$axios.get(url).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.report = data.row.credit_report
                        this.messageReport = data.row.message
                        if(this.report){
                            this.lengthsCreditReports.dbmAccounts=this.report.dbmAccounts.length
                            this.lengthsCreditReports.otherAccounts=this.report.otherAccounts.length
                        }
                    }
                })
            },
            getClientPaymentResume() {
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.CONSULTANT_OPS.GET_CLIENTS_TO_MANAGER
                this.$axios.post(url, {id: this.client.id}).then(response => {
                this.$showLoader(false)
                let data = response.data
                if (data[this.$v.API_SUCCESS]) {
                    this.clientPaymentResume = data.rows[0]
                } else { this.$validateSession(data) }
                })
            },
            getHistoryEvent(page){
                let limit = this.historyPagination.perPage
                let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_USER_HISTORY + "?offset=" + limit*(page - 1) + "&limit=" + limit + "&user=" + this.client.id
				if(!this.isAdmin) url += "&consultant=" + this.user.id
                this.$showLoader(true)
                this.$axios.get(url).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.historyTableData = data[this.$v.API_ROWS]
                        let p = data[this.$v.API_ROW]
                        this.historyPagination.total = p['totalItems']
                        this.historyPagination.currentPage = page
                        this.historyPagination.perPage = limit
                    }
                })
            },
            getTracingTableDataCS(page){
                let limit = this.statusTracingPaginationCS.perPage
                let url = this.$v.SERVER + this.$v.SERVICE_OPS.GET_USER_TRACING ;
                let request = {
                    offset: limit*(page - 1),
                    limit: limit,
                    user: this.client.id
                }
                this.$showLoader(true)
                this.$axios.post(url,request).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.statusTracingTableDataCS = data[this.$v.API_ROWS]
                        let p = data[this.$v.API_ROW]
                        this.statusTracingPaginationCS.total = p['totalItems']
                        this.statusTracingPaginationCS.currentPage = page
                        this.statusTracingPaginationCS.perPage = limit
                    }
                })
            },
            getTracingTableDataS(page){
                let limit = this.statusTracingPaginationS.perPage
                let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_SELL_TRACING// + "?offset=" + limit*(page - 1) + "&limit=" + limit + "&user=" + this.client.id
                let request = {
                    offset: limit*(page - 1),
                    limit: limit,
                    user: this.client.id
                }
                this.$showLoader(true)
                this.$axios.post(url,request).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.statusTracingTableDataS = data[this.$v.API_ROWS]
                        let p = data[this.$v.API_ROW]
                        this.statusTracingPaginationS.total = p['totalItems']
                        this.statusTracingPaginationS.currentPage = page
                        this.statusTracingPaginationS.perPage = limit
                    }
                })
            },
            getUserActionsTableData(page){
                let limit = this.userActionsPagination.perPage
                let url = this.$v.SERVER + this.$v.CONSULTANT_OPS.GET_USER_ACTIONS + "?offset=" + limit*(page - 1) + "&limit=" + limit + "&user=" + this.client.id
                this.$showLoader(true)
                this.$axios.get(url).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.userActionsTableData = data[this.$v.API_ROWS]
                        let p = data[this.$v.API_ROW]
                        this.userActionsPagination.total = p['totalItems']
                        this.userActionsPagination.currentPage = page
                        this.userActionsPagination.perPage = limit
                    }
                })
            },
            getUserInactiveTableData(page){
                let limit = this.userInactivePagination.perPage
                let url = this.$v.SERVER + this.$v.CONSULTANT_OPS.GET_INACTIVE_USER //+ "?offset=" + limit*(page - 1) + "&limit=" + limit + "&user=" + this.client.id
                let request = {
                    offset: limit*(page - 1),
                    limit: limit,
                    user: this.client.id
                }
                this.$showLoader(true)
                this.$axios.post(url,request).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.userInactiveTableData = data[this.$v.API_ROWS]
                        let p = data[this.$v.API_ROW]
                        this.userInactivePagination.total = p['totalItems']
                        this.userInactivePagination.currentPage = page
                        this.userInactivePagination.perPage = limit
                    }
                })
            },
            getMovementsTableData(page){
                let limit = this.movementsPagination.perPage
                let url = this.$v.SERVER + this.$v.SERVICE_OPS.GET_USER_MOVEMENTS
                let request = {
                    offset: limit*(page - 1),
                    limit: limit,
                    id: this.client.id
                }
                this.$showLoader(true)
                this.$axios.post(url,request).then((response) => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data[this.$v.API_SUCCESS]) {
                        this.movementsTableData = data[this.$v.API_ROWS]
                        let p = data[this.$v.API_ROW]
                        this.movementsPagination.total = p['totalItems']
                        this.movementsPagination.currentPage = page
                        this.movementsPagination.perPage = limit
                    }
                })
            },
            getTitleAndWidthProgressBar(){
                let titleP="PROGRESO FALTANTE DEL CLIENTE:\n"
                if(!this.client.step_basic_information) titleP+="-Información básica.\n"
                else this.widthProgressBar="width: 10%"
                if(!this.client.step_basic_information2) titleP+="-Información básica 2.\n"
                else this.widthProgressBar="width: 20%"
                if(!this.client.step_address_information) titleP+="-Domicilio.\n"
                else this.widthProgressBar="width: 30%"
                if(!this.client.step_official_id) titleP+="-Identificación oficial.\n"
                else this.widthProgressBar="width: 40%"
                if(!this.client.step_credit_report_signature) titleP+="-Firma reporte de crédito.\n"
                else this.widthProgressBar="width: 50%"
                if(!this.client.step_credit_report) titleP+="-Reporte de crédito.\n"
                else this.widthProgressBar="width: 60%"
                if(!this.client.step_program_calculation) titleP+="-Programa de cálculo.\n"
                else this.widthProgressBar="width: 70%"
                if(!this.client.step_complete_profile) titleP+="-Perfil completo.\n"
                else this.widthProgressBar="width: 80%"
                if(!this.client.step_contract) titleP+="-Contrato.\n"
                else this.widthProgressBar="width: 90%"
                if(!this.client.step_active) titleP+="-Activo."
                else this.widthProgressBar="width: 100%"
                this.titleProgressBar=titleP
            },
            getMessageReport(message){
                if(message.length>50) return "Contactar con soporte"
                return message
            },
            showCalcClick() {
                let dbmAccounts=this.report['dbmAccounts']
                let newDebts = new Array
                for(let i=0;i<dbmAccounts.length;i++){
                    newDebts.push({
                        bankid: dbmAccounts[i].bank.id,
                        bank: dbmAccounts[i].bank.name,
                        amount: dbmAccounts[i].SaldoActual
                    })
                }
                let request = {
                    name: this.client.name,
                    lastname: this.client.lastname_1,
                    period: this.period,
                    debts: newDebts
                }
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.OPS.CALCULATE
                this.$axios.post(url, request).then(response => {
                    this.$showLoader(false)
                    let data = response.data
                    if (data.success) {
                        this.dbmAccountsCalculations=data.row
                        this.setCalc(this.dbmAccountsCalculations)
                    }
                })
            },
            setTypeMessage(type){
                this.typeTheMessage = type
                this.sendMessageModal = true
            },
            setCalc(calculos){
                this.calculos = calculos
                this.calcModal=true
            },
            typeTracingTable(type){
                this.tracingModal=true
                this.tracingStatus=type
                this.newTrace.status=null
            }
        }
    };
</script>
<style></style>